import React from 'react'
import { Map, fromJS } from 'immutable';
import { getPath, getRatio } from '../helpers/ShapeHelper';
import config from '../config/app.json';
import { errorlog } from '../helpers/ErrorLogService';

export default class TransformManagerComponent extends React.Component {

	constructor(props) {
		super(props);
		this.selectionBox            = {};
		this.keyPressUpdate          = {};
		this.initialSelectionBox     = {};
		this.selectedItems           = Map({});
		this.groupedItems            = Map({});
		this.mouseStartPosition      = {};
		this.currentItemContainer    = "workspaceItems";
		this.initiateMove            = this.initiateMove.bind(this);
		this.moveSelection           = this.moveSelection.bind(this);
		this.stopMove                = this.stopMove.bind(this);
		this.moveItem                = this.moveItem.bind(this);
		this.initiateResize          = this.initiateResize.bind(this);
		this.resizeSelection         = this.resizeSelection.bind(this);
		this.stopResize              = this.stopResize.bind(this);
		this.resizeTextContainer     = this.resizeTextContainer.bind(this);
		this.getResizePosition       = this.getResizePosition.bind(this);
		this.initiateRotate          = this.initiateRotate.bind(this);
		this.rotateSelection         = this.rotateSelection.bind(this);
		this.stopRotate              = this.stopRotate.bind(this);
		this.getTextBounds           = this.getTextBounds.bind(this);
		this.handleShortcuts         = this.handleShortcuts.bind(this);
		this.moveControlPoint        = this.moveControlPoint.bind(this);
		this.controlShape            = this.controlShape.bind(this);
		this.tabChanged              = this.tabChanged.bind(this);
		this.anchorScales            = null;
		this.anchorAngles            = null;
		this.restrictedSelectionBox  = fromJS({});
		this.restrictBounds          = false;
		this.lockRotate              = false;
		this.state                   = { prevSelectedObjects: {} };
		this.snapPoints              = [];
		this.xSnapPoints             = [];
		this.ySnapPoints             = [];
		this.widthLocked             = false;
		this.lockedWidth             = null;
		this.heightLocked            = false;
		this.lockedHeight            = null;
		this.cornerResize            = this.props.cornerResize;
		this.appUrl                  = config['APPICONS'][config['APPICONS']['current']];
		this.transformingTimer       = null;
		this.transformTimeout        = 500;
		this.rotateCount             = 0;
	}

	/*
	Lifecycles
	*/

	static getDerivedStateFromProps(props, state) {

		if (props.selectedObjects !== state.prevSelectedObjects) {
			return {
				selectedObjects: props.selectedObjects,
				prevSelectedObjects: state.selectedObjects,
				selectedItems: props.selectedItems,
				prevSelectedItems: state.selectedItems,
			};
		}
		else
			return null;
	}

	componentDidMount() {

		if (this.props.selectedItems.size > 0 && this.props.currentPosition !== null) {

			this.simulate(this.selectionBoxElement.getElementsByClassName("inner-box")[0], "mousedown", { pointerX: this.props.currentPosition.get("x"), pointerY: this.props.currentPosition.get("y") });
		}


		if (this.props.selectedCamera !== "" && this.props.selectedCamera !== undefined) {
			this.currentItemContainer = "workspaceCameras";
			this.restrictBounds = true;
			this.lockRotate = true;
			this.cornerResize = false;
		}

		this.setSnapPoints();
		window.addEventListener("blur", this.tabChanged, false);
	}

	componentWillUnmount() {
		window.removeEventListener('mousemove', this.moveSelection, false);
		window.removeEventListener("mouseup", this.stopMove, false);
		window.removeEventListener("blur", this.tabChanged, false);
	}

	tabChanged(e) {
		try {
		this.ctrlPressed = false;
		} catch (error) {
			//Error Severity: LOW
			errorlog(error, error.message, "TransformManagerComponent-tabChanged")
	     }		
	}

	setSnapPoints() {
		this.snapPoints = []; this.xSnapPoints = []; this.ySnapPoints = [];
		if (this.props.workspaceGrid) {
			this.snapPoints = [{ x: 0, y: 0, width: this.props.workspaceWidth, height: this.props.workspaceHeight, left: true }, { x: this.props.workspaceWidth / 2, y: this.props.workspaceHeight / 2, width: this.props.workspaceWidth, height: this.props.workspaceHeight, center: true }, { x: this.props.workspaceWidth, y: this.props.workspaceHeight, width: this.props.workspaceWidth, height: this.props.workspaceHeight, right: true }];
			for (var i = 0; i < 8; i++) {
				for (var j = 0; j < 8; j++) {
					this.snapPoints.push({ x: i * this.props.workspaceWidth / 8, y: j * this.props.workspaceHeight / 8, width: this.props.workspaceWidth, height: this.props.workspaceHeight });
				}
			}
		} else {
			if (this.currentItemContainer === "workspaceItems") {
				this.xSnapPoints.push.apply(this.xSnapPoints, [{ x: 0, y: 0, height: this.props.workspaceHeight }, { x: this.props.workspaceWidth / 2, y: 0, height: this.props.workspaceHeight }, { x: this.props.workspaceWidth, y: 0, height: this.props.workspaceHeight }]);

				this.ySnapPoints.push.apply(this.ySnapPoints, [{ x: 0, y: 0, width: this.props.workspaceWidth }, { x: 0, y: this.props.workspaceHeight / 2, width: this.props.workspaceWidth }, { x: 0, y: this.props.workspaceHeight, width: this.props.workspaceWidth }]);

				this.snapPoints.push({ x: 0, y: 0, width: this.props.workspaceWidth, height: this.props.workspaceHeight }, { x: this.props.workspaceWidth / 2, y: this.props.workspaceHeight / 2, width: this.props.workspaceWidth, height: this.props.workspaceHeight }, { x: this.props.workspaceWidth, y: this.props.workspaceHeight, width: this.props.workspaceWidth, height: this.props.workspaceHeight });

				if (this.props.unSelectedObjects !== null && this.props.unSelectedObjects.size > 0) {
					this.props.unSelectedObjects.entrySeq().forEach(([key, single_item]) => {

						let bound = this.getSelectionBoxBounds({ x: single_item.get("x"), y: single_item.get("y"), cx: single_item.get("x") + single_item.get("width") / 2, cy: single_item.get("y") + single_item.get("height") / 2, width: single_item.get("width"), height: single_item.get("height"), angle: single_item.get("angle") });

						this.snapPoints.push({ x: bound.x, y: bound.y, width: single_item.get("width"), height: single_item.get("height"), left: true }, { x: bound.x + bound.width / 2, y: bound.y + bound.height / 2, width: single_item.get("width"), height: single_item.get("height"), center: true }, { x: bound.x + bound.width, y: bound.y + bound.height, width: single_item.get("width"), height: single_item.get("height"), right: true });

						this.xSnapPoints.push.apply(this.xSnapPoints, [{ x: bound.x, y: bound.y, height: bound.height }, { x: bound.x + bound.width / 2, y: bound.y, height: bound.height }, { x: bound.x + bound.width, y: bound.y, height: bound.height }]);

						this.ySnapPoints.push.apply(this.ySnapPoints, [{ x: bound.x, y: bound.y, width: bound.width }, { x: bound.x, y: bound.y + bound.height / 2, width: bound.width }, { x: bound.x, y: bound.y + bound.height, width: bound.width }]);
					});
				}
			} else if (this.currentItemContainer === "workspaceCameras") {

				this.xSnapPoints.push.apply(this.xSnapPoints, [{ x: this.props.workspaceWidth / 2, y: 0, height: this.props.workspaceHeight }]);

				this.ySnapPoints.push.apply(this.ySnapPoints, [{ x: 0, y: this.props.workspaceHeight / 2, width: this.props.workspaceWidth }]);

				this.snapPoints.push({ x: this.props.workspaceWidth / 2, y: this.props.workspaceHeight / 2, width: this.props.workspaceWidth, height: this.props.workspaceHeight });

				if (this.props.unSelectedCameras !== null && this.props.unSelectedCameras.size > 0) {
					this.props.unSelectedCameras.entrySeq().forEach(([key, single_item]) => {

						let bound = this.getSelectionBoxBounds({ x: single_item.get("x"), y: single_item.get("y"), cx: single_item.get("x") + single_item.get("width") / 2, cy: single_item.get("y") + single_item.get("height") / 2, width: single_item.get("width"), height: single_item.get("height"), angle: single_item.get("angle") });

						this.snapPoints.push({ x: bound.x, y: bound.y, width: single_item.get("width"), height: single_item.get("height"), left: true }, { x: bound.x + bound.width / 2, y: bound.y + bound.height / 2, width: single_item.get("width"), height: single_item.get("height"), center: true }, { x: bound.x + bound.width, y: bound.y + bound.height, width: single_item.get("width"), height: single_item.get("height"), right: true });

						this.xSnapPoints.push.apply(this.xSnapPoints, [{ x: bound.x, y: bound.y, height: bound.height }, { x: bound.x + bound.width / 2, y: bound.y, height: bound.height }, { x: bound.x + bound.width, y: bound.y, height: bound.height }]);

						this.ySnapPoints.push.apply(this.ySnapPoints, [{ x: bound.x, y: bound.y, width: bound.width }, { x: bound.x, y: bound.y + bound.height / 2, width: bound.width }, { x: bound.x, y: bound.y + bound.height, width: bound.width }]);
					});
				}
			}
		}
	}

	componentDidUpdate(prevProps, prevState) {

		if (this.props.selectedItems !== prevProps.selectedItems) {
				var elements = document.querySelectorAll(".type-scr");
				for (var i = 0; i < elements.length; i++) {
					elements[i].style.display = "none";
				}
		}
		if(this.props.textStatus!== prevProps.textStatus){
             if(this.props.textStatus.get("id")!==prevProps.textStatus.get("id")&&this.props.isTextClicked){
				 this.props.setIsTextClicked(false);
			 }
		}

		if (!this.props.isWorkspaceTextFocus && this.props.shortcutName !== prevProps.shortcutName && this.props.shortcutName !== "")
			this.handleShortcuts(this.props.shortcutName);
		else if (!this.props.isWorkspaceTextFocus && this.props.shortcutName !== prevProps.shortcutName && this.props.shortcutName === "") {

			if (prevProps.shortcutName === "LEFT_ARROW" || prevProps.shortcutName === "LEFT_ARROW_AGAIN" || prevProps.shortcutName === "RIGHT_ARROW" || prevProps.shortcutName === "RIGHT_ARROW_AGAIN" || prevProps.shortcutName === "UP_ARROW" || prevProps.shortcutName === "UP_ARROW_AGAIN" || prevProps.shortcutName === "DOWN_ARROW" || prevProps.shortcutName === "DOWN_ARROW_AGAIN" || prevProps.shortcutName === "SHIFT_LEFT_ARROW" || prevProps.shortcutName === "SHIFT_LEFT_ARROW_AGAIN" || prevProps.shortcutName === "SHIFT_RIGHT_ARROW" || prevProps.shortcutName === "SHIFT_RIGHT_ARROW_AGAIN" || prevProps.shortcutName === "SHIFT_UP_ARROW" || prevProps.shortcutName === "SHIFT_UP_ARROW_AGAIN" || prevProps.shortcutName === "SHIFT_DOWN_ARROW" || prevProps.shortcutName === "SHIFT_DOWN_ARROW_AGAIN") {
				this.transformingByKey = false;
				this.hideSnaplines();

				this.updateInitialSelectionBox({ transforming: false, moving: false, x: this.keyPressUpdate.x, y: this.keyPressUpdate.y, cx: this.keyPressUpdate.x + this.keyPressUpdate.width / 2, cy: this.keyPressUpdate.y + this.keyPressUpdate.height / 2 });

				this.props.moveUpdate({ "items": this.selectedItems, "children": this.groupedItems, "selectedScene": this.props.selectedScene, "currentContainer": this.currentItemContainer, selectedItems: this.props.selectedItems }, this.props.socket);
			}
		}

		if ((prevProps.selectedItems !== this.props.selectedItems || this.props.currentPosition !== prevProps.currentPosition) && this.props.selectedItems.size > 0 && this.props.currentPosition !== null) {
			this.simulate(this.selectionBoxElement.getElementsByClassName("inner-box")[0], "mousedown", { pointerX: this.props.currentPosition.get("x"), pointerY: this.props.currentPosition.get("y") });
		}

		if (this.props.selectedItems !== prevProps.selectedItems && this.props.selectedItems.size > 0) {

			if (this.currentItemContainer !== "workspaceItems")
				this.currentItemContainer = "workspaceItems";
			this.restrictBounds = false;
			this.lockRotate = false;
			if (this.props.cornerResize !== undefined && this.props.cornerResize)
				this.cornerResize = true;
		}
		else if (this.props.selectedCamera !== prevProps.selectedCamera && this.props.selectedCamera !== "") {
			if (this.currentItemContainer !== "workspaceCameras")
				this.currentItemContainer = "workspaceCameras";
			this.restrictBounds = true;
			this.lockRotate = true;
			this.cornerResize = false;
		}

		this.setSnapPoints();

	}

	eventMatchers = {
		'HTMLEvents': /^(?:load|unload|abort|error|select|change|submit|reset|focus|blur|resize|scroll)$/,
		'MouseEvents': /^(?:click|dblclick|mouse(?:down|up|over|move|out))$/
	}

	defaultOptions = {
		pointerX: 0,
		pointerY: 0,
		button: 0,
		ctrlKey: false,
		altKey: false,
		shiftKey: false,
		metaKey: false,
		bubbles: true,
		cancelable: true
	}

	simulate(element, eventName) {
		var options = this.extend(this.defaultOptions, arguments[2] || {});
		var oEvent, eventType = null;

		for (var name in this.eventMatchers) {
			if (this.eventMatchers[name].test(eventName)) { eventType = name; break; }
		}

		if (!eventType)
			throw new SyntaxError('Only HTMLEvents and MouseEvents interfaces are supported');

		if (document.createEvent) {
			oEvent = document.createEvent(eventType);
			if (eventType === 'HTMLEvents') {
				oEvent.initEvent(eventName, options.bubbles, options.cancelable);
			}
			else {
				oEvent.initMouseEvent(eventName, options.bubbles, options.cancelable, document.defaultView,
					options.button, options.pointerX, options.pointerY, options.pointerX, options.pointerY,
					options.ctrlKey, options.altKey, options.shiftKey, options.metaKey, options.button, element);
			}
			element.dispatchEvent(oEvent);
		}
		else {
			options.clientX = options.pointerX;
			options.clientY = options.pointerY;
			var evt = document.createEventObject();
			oEvent = this.extend(evt, options);
			element.fireEvent('on' + eventName, oEvent);
		}
		return element;
	}

	extend(destination, source) {
		for (var property in source)
			destination[property] = source[property];
		return destination;
	}

	disableClick(selector) {
		var elements = document.querySelectorAll(selector);
		for (var i = 0; i < elements.length; i++) {
			if (elements[i].className.indexOf("pointer-events-none") === -1) {
				elements[i].classList.add("pointer-events-none");
			}
		}
	}

	enableClick(selector) {
		var elements = document.querySelectorAll(selector);
		for (var i = 0; i < elements.length; i++) {
			if (elements[i].className.indexOf("pointer-events-none") !== -1)
				elements[i].classList.remove("pointer-events-none");
		}
	}

	updateInitialSelectionBox(obj) {
		this.selectionBox = Object.assign(this.selectionBox, obj);
		this.initialSelectionBox = Object.assign(this.initialSelectionBox, obj);
	}

	getMousePosition(e) {
	try {
		let currentX = e.clientX - document.getElementById('workspace').offsetLeft, currentY = e.clientY - document.getElementById('workspace').offsetTop;
		return { x: currentX, y: currentY };
	} catch (error) {
		//Error Severity: LOW
		errorlog(error, error.message, "TransformManagerComponent-getMousePosition")
	}
	}

	hideSnaplines() {
		let snapLines = document.getElementsByClassName("snap-line");
		for (var i = 0; i < snapLines.length; i++) {
			snapLines[i].style.display = "none";
		}
	}

	getWorkspaceBounds() {
		let workspace = document.getElementById('workspace');
		return { x: workspace.offsetLeft, y: workspace.offsetTop, width: workspace.offsetWidth, height: workspace.offsetHeight };
	}

	composedPath(el) {
		var path = [];
		while (el) {
			path.push(el);
			if (el.tagName === 'HTML') {
				path.push(document);
				path.push(window);
				return path;
			}
			el = el.parentElement;
		}
	}

	isMouseOn(e, value) {
		try {
		var i;
		var path_array = e.path || (e.composedPath && e.composedPath()) || this.composedPath(e.target);
		if (path_array.length > 0) {
			for (i = 0; i < path_array.length; i++) {
				if (path_array[i].className !== undefined && typeof (path_array[i].className) !== "object") {
					if (path_array[i].className.indexOf(value) !== -1) {
						return true;
					}
				}
				else if (path_array[i].className !== undefined && typeof (path_array[i].className) === "object") {
					if (path_array[i].className.animVal === value)
						return true;
				}
			}
		}
		return false;
	} catch (error) {
		//Error Severity: LOW
		errorlog(error, error.message, "TransformManagerComponent-isMouseOn")
	}
	}

	isRightMouse(e) {
		try {
		var isRightMB;
		e = e || window.event;
		if ("which" in e)
			isRightMB = e.which === 3;
		else if ("button" in e)
			isRightMB = e.button === 2;

		return isRightMB;
		} catch (error) {
			//Error Severity: LOW
			errorlog(error, error.message, "TransformManagerComponent-isRightMouse")
		}		
	}

	isMouseOnSelectionBox(e) {
		try {
		let workspace_bounds = this.getWorkspaceBounds(), currentX = e.clientX - workspace_bounds.x, currentY = e.clientY - workspace_bounds.y;
		if (this.selectionBox.x !== null) {
			if ((currentX > (this.selectionBox.x) && currentY > (this.selectionBox.y) && currentX < (this.selectionBox.x + this.selectionBox.width)
				&& currentY < (this.selectionBox.y + this.selectionBox.height)) && !this.isMouseOn(e, "handle"))
				return true;
		}
		return false;
		} catch (error) {
			//Error Severity: LOW
			errorlog(error, error.message, "TransformManagerComponent-isMouseOnSelectionBox")
		}
	}

	setCursor(e, action) {

	}

	resetCursor(e) {
	try {
		if (!this.selectionBox.transforming) {
			document.getElementById('workspace').style.cursor = 'default';
		}
	} catch (error) {
		//Error Severity: LOW
		errorlog(error, error.message, "TransformManagerComponent-resetCursor")
	}
	}

	/*
	  Move
	*/

	getXSnapPoint(point, r, array) {
		const result = array.filter(arr => Math.abs(arr.x - point) <= r);
		return result;
	}

	getYSnapPoint(point, r, array) {
		const result = array.filter(arr => Math.abs(arr.y - point) <= r);
		return result;
	}


	getSelectionSnapPoints(x, y) {
		var cx = x + (this.selectionBox.width * this.props.zoomFactor) / 2;
		var cy = y + (this.selectionBox.height * this.props.zoomFactor) / 2;

		let bounds = this.getSelectionBoxBounds({ x: x, y: y, cx: cx, cy: cy, width: (this.selectionBox.width * this.props.zoomFactor), height: (this.selectionBox.height * this.props.zoomFactor), angle: this.selectionBox.angle });

		let boundX = bounds.x / this.props.zoomFactor, boundY = bounds.y / this.props.zoomFactor, boundWidth = bounds.width / this.props.zoomFactor, boundHeight = bounds.height / this.props.zoomFactor;
		let selectionLeft = boundX,
			selectionTop = boundY,
			selectionRight = boundX + boundWidth,
			selectionBottom = boundY + boundHeight,
			selectionCenterX = boundX + boundWidth / 2,
			selectionCenterY = boundY + boundHeight / 2;

		return { left: selectionLeft, top: selectionTop, centerX: selectionCenterX, centerY: selectionCenterY, right: selectionRight, bottom: selectionBottom };
	}

	handleShortcuts(option) {
		if (this.selectionBox.x !== null) {
			var x = this.selectionBox.x, y = this.selectionBox.y;

			var d = 1, sd = 10;
			switch (option) {
				case "RIGHT_ARROW":
				case "RIGHT_ARROW_AGAIN":
					x += d;
					break;
				case "LEFT_ARROW":
				case "LEFT_ARROW_AGAIN":
					x -= d;
					break;
				case "UP_ARROW":
				case "UP_ARROW_AGAIN":
					y -= d;
					break;
				case "DOWN_ARROW":
				case "DOWN_ARROW_AGAIN":
					y += d;
					break;
				case "SHIFT_RIGHT_ARROW":
				case "SHIFT_RIGHT_ARROW_AGAIN":
					x += sd;
					break;
				case "SHIFT_LEFT_ARROW":
				case "SHIFT_LEFT_ARROW_AGAIN":
					x -= sd;
					break;
				case "SHIFT_UP_ARROW":
				case "SHIFT_UP_ARROW_AGAIN":
					y -= sd;
					break;
				case "SHIFT_DOWN_ARROW":
				case "SHIFT_DOWN_ARROW_AGAIN":
					y += sd;
					break;
				default:
					break;
			}

			if ((this.selectionBox.x !== x || this.selectionBox.y !== y) && !this.props.textStatus.get("isFocused")) {

				this.transformingByKey = true;
				if (!this.props.transformStatus.get("transforming")) {
					this.props.updateTransformStatus({ transforming: true, moving: true });
				}
				this.moveItem(x * this.props.zoomFactor, y * this.props.zoomFactor);
				if (this.transformingTimer) clearTimeout(this.transformingTimer);
				this.transformingTimer = setTimeout(function () {
					this.props.moveUpdate({ "items": this.selectedItems, "children": this.groupedItems, "selectedScene": this.props.selectedScene, "currentContainer": this.currentItemContainer, selectedItems: this.props.selectedItems }, this.props.socket);
				}.bind(this), this.transformTimeout);
			}
		}
	}

	moveItem(x, y) {

		var selectionBox = this.selectionBoxElement;
		let workspaceBounds = this.getWorkspaceBounds();

		if (this.restrictBounds !== undefined && this.restrictBounds) {
			let outLineWidth = 0;
			if (x - outLineWidth < 0) x = outLineWidth; if (y - outLineWidth < 0) y = outLineWidth;
			if (y + (this.selectionBox.height * this.props.zoomFactor) + outLineWidth > document.getElementById('workspace').offsetHeight)
				y = document.getElementById('workspace').offsetHeight - (this.selectionBox.height * this.props.zoomFactor) - outLineWidth;
			if (x + (this.selectionBox.width * this.props.zoomFactor) + outLineWidth > document.getElementById('workspace').offsetWidth)
				x = document.getElementById('workspace').offsetWidth - (this.selectionBox.width * this.props.zoomFactor) - outLineWidth;
		}


		if (!this.transformingByKey) {

			var selectionPoints = this.getSelectionSnapPoints(x, y), i = 0;

			let xSnapped = false, ySnapped = false;

			var r = 2;
			if (this.props.workspaceGrid)
				r = 4;
			for (i = 0; i < this.snapPoints.length; i++) {

				let dX = (selectionPoints.left - this.snapPoints[i].x) * this.props.zoomFactor, dY = (selectionPoints.top - this.snapPoints[i].y) * this.props.zoomFactor;
				let dCX = (selectionPoints.centerX - this.snapPoints[i].x) * this.props.zoomFactor, dCY = (selectionPoints.centerY - this.snapPoints[i].y) * this.props.zoomFactor;

				let dRX = (selectionPoints.right - this.snapPoints[i].x) * this.props.zoomFactor, dRY = (selectionPoints.bottom - this.snapPoints[i].y) * this.props.zoomFactor;

				let snappedX = (Math.abs(dX) <= r) ? dX : (Math.abs(dCX) <= (this.snapPoints[i].center ? 6 : r)) ? dCX : (Math.abs(dRX) <= r) ? dRX : false;
				let snappedY = (Math.abs(dY) <= r) ? dY : (Math.abs(dCY) <= (this.snapPoints[i].center ? 6 : r)) ? dCY : (Math.abs(dRY) <= r) ? dRY : false;

				if (snappedX !== false && !xSnapped) {
					x = parseFloat((x - snappedX).toFixed(2)); xSnapped = true;
				}

				if (snappedY !== false && !ySnapped) {
					y = parseFloat((y - snappedY).toFixed(2)); ySnapped = true;
				}
			}

		}

		let selectionCX = (x / this.props.zoomFactor) + (this.selectionBox.width) / 2,
			selectionCy = (y / this.props.zoomFactor) + (this.selectionBox.height) / 2;
		selectionBox.style.transform = "translate(" + (x) + "px, " + (y) + "px) rotateZ(" + this.selectionBox.angle + "deg)";

		var allItems = this.selectedItems;

			allItems.entrySeq().forEach(([key, item]) => {
				let item_x = Math.cos((item.get("angle_to_center") + this.initialSelectionBox.angle) * Math.PI / 180) * Math.abs(item.get("dis_to_center")) + selectionCX - item.get("width") / 2;

				let item_y = Math.sin((item.get("angle_to_center") + this.initialSelectionBox.angle) * Math.PI / 180) * Math.abs(item.get("dis_to_center")) + selectionCy - item.get("height") / 2;

				let item_to_update = Map({ "x": item_x, "y": item_y });
				allItems = allItems.set(key, item.merge(item_to_update));
				if (document.getElementById(key) !== null) {
					let flipPos = item.get("flipPosition");
					let flip = (flipPos === 1) ? " scaleX(-1)" : (flipPos === 2) ? " scaleY(-1)" : (flipPos === 3) ? " scaleX(-1) scaleY(-1)" : "";
					document.getElementById(key).style.transform = "translate(" + (item_x * this.props.zoomFactor).toFixed(2) + "px, " + (item_y * this.props.zoomFactor).toFixed(2) + "px) rotateZ(" + item.get("angle") + "deg)" + flip;
				}
			});

		this.selectedItems = allItems;

		this.selectionBox = Object.assign(this.selectionBox, { "x": x / this.props.zoomFactor, "y": y / this.props.zoomFactor });

		if (this.props.shortcutName !== "")
			this.keyPressUpdate = Object.assign(this.keyPressUpdate, this.selectionBox);


		var selectionSnaps = this.getSelectionSnapPoints(x, y);

		var xSelectionPoints = [selectionSnaps.left, selectionSnaps.centerX, selectionSnaps.right];
		var ySelectionPoints = [selectionSnaps.top, selectionSnaps.centerY, selectionSnaps.bottom];

		if (!this.props.workspaceGrid) {
			r = 0.5;
			for (i = 0; i < xSelectionPoints.length; i++) {
				let snapPoint = this.getXSnapPoint(xSelectionPoints[i], r, this.xSnapPoints);
				let verticalLine = document.getElementsByClassName("vertical-line")[i];
				if (snapPoint.length > 0) {
					let verX = ((snapPoint[0].x * this.props.zoomFactor) + workspaceBounds.x), verY = (snapPoint[0].y * this.props.zoomFactor) + workspaceBounds.y, verHeight = snapPoint[0].height * this.props.zoomFactor;
					if (verY > (selectionSnaps.top * this.props.zoomFactor) + workspaceBounds.y) {
						let dY = verY - ((selectionSnaps.top * this.props.zoomFactor) + workspaceBounds.y);
						verY -= dY;
						verHeight += dY;
					}
					if (verY + verHeight < (selectionSnaps.bottom * this.props.zoomFactor) + workspaceBounds.y) {
						let dY = ((selectionSnaps.bottom * this.props.zoomFactor) + workspaceBounds.y) - (verY + verHeight);
						verHeight += dY;
					}
					verticalLine.style.height = (verHeight) + "px";
					verticalLine.style.left = ((verX - 0.5)) + "px";
					verticalLine.style.top = ((verY - 0.5)) + "px";
					verticalLine.style.display = "block";
				} else {
					verticalLine.style.display = "none";
				}
			}

			for (i = 0; i < ySelectionPoints.length; i++) {
				let snapPoint = this.getYSnapPoint(ySelectionPoints[i], r, this.ySnapPoints);
				let horizontalLine = document.getElementsByClassName("horizontal-line")[i];
				if (snapPoint.length > 0) {
					let horX = ((snapPoint[0].x * this.props.zoomFactor) + workspaceBounds.x), horY = ((snapPoint[0].y * this.props.zoomFactor) + workspaceBounds.y), horWidth = snapPoint[0].width * this.props.zoomFactor;
					if (horX > (selectionSnaps.left * this.props.zoomFactor) + workspaceBounds.x) {
						let dX = horX - ((selectionSnaps.left * this.props.zoomFactor) + workspaceBounds.x);
						horX -= dX;
						horWidth += dX;
					}
					if (horX + horWidth < (selectionSnaps.right * this.props.zoomFactor) + workspaceBounds.x) {
						let dX = ((selectionSnaps.right * this.props.zoomFactor) + workspaceBounds.x) - (horX + horWidth);
						horWidth += dX;
					}
					horizontalLine.style.width = (horWidth) + "px";
					horizontalLine.style.left = (horX - 0.5) + "px";
					horizontalLine.style.top = (horY - 0.5) + "px";
					horizontalLine.style.display = "block";
				} else {
					horizontalLine.style.display = "none";
				}
			}
		}

	}

	initiateMove(e) {
       try {
		let target = e.target;
		if (target.className.indexOf("crop-handle") !== -1) {
			return;
		}
		e.stopPropagation();

		if ((e.timeStamp - this.lastDown) < 250 && !this.isRightMouse(e)) {
			if (this.props.selectedItems.size === 1) {
			
				 if (!this.props.isCropping  && (this.selectedItems.get(this.props.selectedItems.get(0)).get("type") === "IMG" || this.selectedItems.get(this.props.selectedItems.get(0)).get("type") === "STOCKIMG" || (this.selectedItems.get(this.props.selectedItems.get(0)).get("type") === "UPLOADS" && this.selectedItems.get(this.props.selectedItems.get(0)).get("subType") === "UPIMAGE")))
					this.props.toggleCrop();
				else if (!this.props.isFraming && this.selectedItems.get(this.props.selectedItems.get(0)).get("type") === "FRAME")
					this.props.toggleFrame();

				if (this.selectedItems.getIn([this.props.selectedItems.get(0), "type"]) === "SHAPE") {

					this.props.updateTextStatus({ id: this.props.selectedItems.get(0), isFocused: true, container: "workspaceItems", isRTL: this.selectedItems.getIn([this.props.selectedItems.get(0), "textData", "formats", "others", "isRTL"]), isGrouped: false, type: "SHAPE", fontSize: parseFloat(this.selectedItems.getIn([this.props.selectedItems.get(0), "textData", "formats", "containerStyle", "fontSize"]), 10) });

				}
			}

			if (this.props.selectedItems.size === 1 && this.props.animakerType === 'lite')
				this.disableClick(".selectionBox");
		}
		this.lastDown = e.timeStamp;
		this.moved = false;

		if (this.props.selectedItems.size === 1 && this.props.animakerType === 'full')
			this.disableClick(".selectionBox");

		e.preventDefault();

		let isMoveLocked = (this.lockMove !== undefined && this.lockMove) ? true : false;
		if (!isMoveLocked) {
			this.updateInitialSelectionBox({ transforming: true, moving: true });

			let mouse_position = this.getMousePosition(e);
			this.mouseStartPosition = Object.assign(this.mouseStartPosition, { x: mouse_position.x, y: mouse_position.y, offsetX: ((this.selectionBox.x) - mouse_position.x / this.props.zoomFactor), offsetY: ((this.selectionBox.y) - mouse_position.y / this.props.zoomFactor) });
			if (this.selectionBox)
				window.addEventListener('mousemove', this.moveSelection, false);
			window.addEventListener('mouseup', this.stopMove, false);
		}
		else {
			this.enableClick(".selectionBox");
		}
	} catch (error) {
		//Error Severity: LOW
		errorlog(error, error.message, "TransformManagerComponent-initiateMove")
	}
	}

	moveSelection(e) {
		try {
		if (this.lastDown + 10 < e.timeStamp) {
			if (!this.moved) {
				this.moved = true;
				this.enableClick(".selectionBox");
					this.props.updateTransformStatus({ transforming: true, moving: true });
			}
			e.preventDefault();
			let mouse_position = this.getMousePosition(e), x = parseFloat((mouse_position.x + (this.mouseStartPosition.offsetX * this.props.zoomFactor)).toFixed(2)), y = parseFloat((mouse_position.y + (this.mouseStartPosition.offsetY * this.props.zoomFactor)).toFixed(2));

			this.moveItem(x, y);
		}
	} catch (error) {
		//Error Severity: LOW
		errorlog(error, error.message, "TransformManagerComponent-moveSelection")
	}
	}

	stopMove(e) {
		try {

			this.enableClick(".selectionBox");
			this.updateInitialSelectionBox({ transforming: false, moving: false, x: this.selectionBox.x, y: this.selectionBox.y, cx: this.selectionBox.x + this.selectionBox.width / 2, cy: this.selectionBox.y + this.selectionBox.height / 2 });
			if (this.moved) {
				e.preventDefault();
				if (!this.props.isToolCropping) {
					
						let mouse_position = this.getMousePosition(e),
						x = parseFloat((mouse_position.x + (this.mouseStartPosition.offsetX * this.props.zoomFactor)).toFixed(2)),
						y = parseFloat((mouse_position.y + (this.mouseStartPosition.offsetY * this.props.zoomFactor)).toFixed(2));

						this.moveItem(x, y);
						this.props.moveUpdate({ "items": this.selectedItems, "children": this.groupedItems, isMultimove: this.state.selectedObjects.size === 1 && this.state.selectedObjects.first().get("isMultimove") && this.props.animakerType === 'full', isSwitch: this.state.selectedObjects.size === 1 && this.state.selectedObjects.first().get("isSwitch") && this.props.animakerType === 'full', "selectedScene": this.props.selectedScene, "currentContainer": this.currentItemContainer, selectedItems: this.props.selectedItems }, this.props.socket);
					
				} else {
					let toUpdate = { x: this.selectionBox.x / this.props.workspaceWidth, y: this.selectionBox.y / this.props.workspaceHeight };
					this.props.updateBg({ selectedScene: this.props.selectedScene, toUpdate: toUpdate, toolCrop: true }, this.props.socket);
				}
			} else {

				this.props.setCurrentPosition(null);

				if (this.props.selectedItems.size === 1 && this.props.animakerType === 'full') {
					if (this.selectedItems.getIn([this.props.selectedItems.get(0), "type"]) === "TEXT") {
						if(this.props.isTextClicked)
						this.props.updateTextStatus({ id: this.props.selectedItems.get(0), isFocused: true, container: "workspaceItems", isRTL: false, isGrouped: this.props.isGrouped, fontSize: parseFloat(this.selectedItems.getIn([this.props.selectedItems.get(0), "textData", "formats", "containerStyle", "fontSize"]), 10), type: "TEXT" });
						else
						this.props.updateTextStatus({ id: this.props.selectedItems.get(0), isFocused: false, container: "workspaceItems", isRTL: false, isGrouped: this.props.isGrouped, fontSize: parseFloat(this.selectedItems.getIn([this.props.selectedItems.get(0), "textData", "formats", "containerStyle", "fontSize"]), 10), type: "TEXT" });
						this.disableClick(".selectionBox");
						if((this.props.textStatus.get("isSelected"))){
							this.props.setIsTextClicked(true);
						  }
					}
				}
				if (this.props.textStatus.get("isFocused"))
					this.disableClick(".selectionBox");
		}


		window.removeEventListener('mousemove', this.moveSelection, false);
		window.removeEventListener('mouseup', this.stopMove, false);
			this.hideSnaplines();
		if (!this.isMouseOnSelectionBox(e))
			this.resetCursor(e);
	} catch (error) {
		//Error Severity: LOW
		errorlog(error, error.message, "TransformManagerComponent-stopMove")
	}
	}

	isFontAutoSize(id, container) {

		if (!container)
			container = "workspaceItems";

		var active_text = (container === "workspaceItems") ? this.props.selectedObjects.getIn([id, "textData"]) : this.props.selectedChildren.getIn([id, "textData"]);
		var result = false;
		var auto_font_size = active_text.getIn(["formats", "others", "isAutoFontSize"]);
		if (auto_font_size !== undefined)
			result = auto_font_size;
		return result;
	}

	getTextBounds(e, id) {
		let handle = this.initialSelectionBox.handle;
		var textItem;
		var textId = id;
		textItem = this.props.selectedObjects.get(id);
		var textElement = document.getElementById(textId), width, height, x, y;
		let textContainer = textElement.getElementsByClassName('text-container')[0];

		if ((handle === "left" || handle === "right")) {

			let mouse_position = this.getMousePosition(e);

			let dx = (mouse_position.x - this.mouseStartPosition.x) / this.props.zoomFactor, dy = (mouse_position.y - this.mouseStartPosition.y) / this.props.zoomFactor, angle = this.initialSelectionBox.angle;

			var newX = this.initialSelectionBox.x, newY = this.initialSelectionBox.y, newWidth = this.initialSelectionBox.width, newHeight = this.initialSelectionBox.height;
			var prevX = this.initialSelectionBox.x, prevY = this.initialSelectionBox.y, prevWidth = this.initialSelectionBox.width;
			var rPx = this.initialSelectionBox.rotated_x, rPy = this.initialSelectionBox.rotated_y;
			var adX = ((dx) * Math.cos(angle * (Math.PI / 180))) + ((dy) * Math.sin(angle * (Math.PI / 180)));

			var rotatedX, rotatedY, r1Px, r1Py, tempY;
			if (handle === "left") {
				newWidth = prevWidth - adX;
				newX = prevX + adX;
				tempY = ((newY) - (newY + newHeight / 2));
				rotatedX = ((newX) - (newX + newWidth / 2)) * Math.cos(angle * (Math.PI / 180)) - tempY * Math.sin(angle * (Math.PI / 180));
				rotatedY = ((newY) - (newY + newHeight / 2)) * Math.sin(angle * (Math.PI / 180)) + tempY * Math.cos(angle * (Math.PI / 180));

				r1Px = (newX) + (rotatedX + (newWidth / 2));
				r1Py = (newY) + (rotatedY + (newHeight / 2));

				newX = prevX - (rPx - r1Px);
				newY = prevY - (rPy - r1Py);

			} else if (handle === "right") {
				newWidth = prevWidth + adX;
				tempY = ((newY) - (newY + newHeight / 2))
				rotatedX = ((newX) - (newX + newWidth / 2)) * Math.cos(angle * (Math.PI / 180)) - tempY * Math.sin(angle * (Math.PI / 180));
				rotatedY = ((newY) - (newY + newHeight / 2)) * Math.sin(angle * (Math.PI / 180)) + tempY * Math.cos(angle * (Math.PI / 180));

				r1Px = (newX) + (rotatedX + (newWidth / 2));
				r1Py = (newY) + (rotatedY + (newHeight / 2));

				newX = prevX - (r1Px - rPx);
				newY = prevY - (r1Py - rPy);
			}

			width = newWidth;
			height = newHeight;
			x = newX;
			y = newY;

			textElement.style.transform = "translate(" + (newX * this.props.zoomFactor) + "px, " + (newY * this.props.zoomFactor) + "px) rotateZ(0deg)";
			textElement.style.width = (width * this.props.zoomFactor) + "px";

			let range = document.createRange();
			range.selectNode(textElement.getElementsByClassName('text-container')[0]);

			let rangeBounds = range.getBoundingClientRect();

			textElement.style.transform = "translate(" + (newX * this.props.zoomFactor) + "px, " + (newY * this.props.zoomFactor) + "px) rotateZ(" + textItem.get("angle") + "deg)";
			let rangeWidth = rangeBounds.width + (this.props.textOffset * this.props.zoomFactor);
			let rangeHeight = rangeBounds.height + (this.props.textOffset * this.props.zoomFactor);
			if (rangeWidth > width * this.props.zoomFactor) {
				width = rangeWidth / this.props.zoomFactor;
			}
			height = rangeHeight / this.props.zoomFactor;
		} else {
			let resize_position = this.getResizePosition(e);

			var scale_x = resize_position.scale_x, scale_y = resize_position.scale_y, cx = resize_position.cx, cy = resize_position.cy;
			let item = this.selectedItems.get(id);

			width = Math.abs(item.get("width") * scale_x); height = Math.abs(item.get("height") * scale_y);
			x = Math.cos((item.get("angle_to_center") + item.get("angle")) * Math.PI / 180) * Math.abs(item.get("dis_to_center") * scale_x) + cx - width / 2;
			y = Math.sin((item.get("angle_to_center") + item.get("angle")) * Math.PI / 180) * Math.abs(item.get("dis_to_center") * scale_y) + cy - height / 2;
			let textOffset = this.props.textOffset;
			if (item.get("type") === "SHAPE")
				textOffset = 0;
			let tsx = ((item.get("width") * scale_x) - textOffset) / item.get("width"), tsy = ((item.get("height") * scale_y) - textOffset) / item.get("height");

			let fontSize = (parseFloat(textItem.getIn(["textData", "formats", "containerStyle", "fontSize"]), 10) * Math.abs(Math.max(tsx, tsy)) * this.props.zoomFactor).toFixed(2);

			textContainer.style.fontSize = fontSize + "px";
			this.props.updateTextStatus({ fontSize: fontSize });
		}
		return { x: x, y: y, width: width, height: height };
	}

	resizeTextContainer(e) {
		try {
		let selectedId = this.selectedItems.keySeq().toArray()[0];
		let textBounds = this.getTextBounds(e, selectedId);
		var selectionBox = this.selectionBoxElement;
		let textWidth = textBounds.width, textHeight = textBounds.height;

		var x = (textBounds.x * this.props.zoomFactor), y = (textBounds.y * this.props.zoomFactor), width = (textWidth * this.props.zoomFactor), height = (textHeight * this.props.zoomFactor);
		selectionBox.style.transform = "translate(" + x + "px, " + y + "px) rotateZ(" + this.selectionBox.angle + "deg)";

		selectionBox.style.width = width + "px";
		selectionBox.style.height = height + "px";

		if (height < 60) {
			if (document.querySelector(".resize-handle.left").className.indexOf("hide-handle") === -1) {
				document.querySelector(".resize-handle.left").classList.add("hide-handle");
			}
			if (document.querySelector(".resize-handle.right").className.indexOf("hide-handle") === -1) {
				document.querySelector(".resize-handle.right").classList.add("hide-handle");
			}
		} else {
			if (document.querySelector(".resize-handle.left").className.indexOf("hide-handle") !== -1) {
				document.querySelector(".resize-handle.left").classList.remove("hide-handle");
			}
			if (document.querySelector(".resize-handle.right").className.indexOf("hide-handle") !== -1) {
				document.querySelector(".resize-handle.right").classList.remove("hide-handle");
			}
		}

		let textElement = document.getElementById(selectedId);
		let textItem;

		textItem = this.props.selectedObjects.get(selectedId);
		textElement.style.transform = "translate(" + x + "px, " + y + "px) rotateZ(" + textItem.get("angle") + "deg)";
		textElement.style.width = width + "px";
		textElement.style.height = height + "px";
	} catch (error) {
		//Error Severity: LOW
		errorlog(error, error.message, "TransformManagerComponent-resizeTextContainer")
	}

	}

	getResizePosition(e) {
		try {
		let mouse_position = this.getMousePosition(e), handle = this.initialSelectionBox.handle;
		let angle = this.selectionBox.angle;
		let dx = (mouse_position.x - this.mouseStartPosition.x) / this.props.zoomFactor, dy = (mouse_position.y - this.mouseStartPosition.y) / this.props.zoomFactor;

		var newX = this.initialSelectionBox.x, newY = this.initialSelectionBox.y, newWidth = this.initialSelectionBox.width, newHeight = this.initialSelectionBox.height;
		var prevX = this.initialSelectionBox.x, prevY = this.initialSelectionBox.y, prevWidth = this.initialSelectionBox.width, prevHeight = this.initialSelectionBox.height;
		var rPx = this.initialSelectionBox.rotated_x, rPy = this.initialSelectionBox.rotated_y;
		var adX = ((dx) * Math.cos(angle * (Math.PI / 180))) + ((dy) * Math.sin(angle * (Math.PI / 180)));
		var adY = ((dy) * Math.cos(angle * (Math.PI / 180))) - ((dx) * Math.sin(angle * (Math.PI / 180)));

		if (!this.cornerResize) {
			adX *= 2;
			adY *= 2;
		}

		var tempX, tempY, rotatedX, rotatedY, r1Px, r1Py;

		switch (handle) {
			case "top-left":
				newWidth = prevWidth - adX;
				newHeight = prevHeight - adY;
				newX = prevX + adX;
				newY = prevY + adY;

				newY = newY - ((newWidth / prevWidth * prevHeight) - newHeight);
				newHeight = newWidth / prevWidth * prevHeight;

				tempX = (newX) - (newX + newWidth / 2);
				tempY = (newY) - (newY + newHeight / 2);

				if (!this.cornerResize) {
					tempX += (newWidth - prevWidth) / 2
					tempY += (newHeight - prevHeight) / 2
				}

				rotatedX = tempX * Math.cos(angle * (Math.PI / 180)) - tempY * Math.sin(angle * (Math.PI / 180));
				rotatedY = tempX * Math.sin(angle * (Math.PI / 180)) + tempY * Math.cos(angle * (Math.PI / 180));

				r1Px = (newX) + (rotatedX + (newWidth / 2));
				r1Py = (newY) + (rotatedY + (newHeight / 2));

				newX = prevX - (rPx - r1Px);
				newY = prevY - (rPy - r1Py);
				break;
			case "top":

				newHeight = prevHeight - adY;
				newY = prevY + adY;

				tempX = (newX) - (newX + newWidth / 2);
				tempY = (newY) - (newY + newHeight / 2);

				if (!this.cornerResize) {
					tempX += (newWidth - prevWidth) / 2;
					tempY += (newHeight - prevHeight) / 2
				}

				rotatedX = tempX * Math.cos(angle * (Math.PI / 180)) - tempY * Math.sin(angle * (Math.PI / 180));
				rotatedY = tempX * Math.sin(angle * (Math.PI / 180)) + tempY * Math.cos(angle * (Math.PI / 180));

				r1Px = (newX) + (rotatedX + (newWidth / 2));
				r1Py = (newY) + (rotatedY + (newHeight / 2));

				newX = prevX - (rPx - r1Px);
				newY = prevY - (rPy - r1Py);

				break;
			case "top-right":

				newWidth = prevWidth + adX;
				newHeight = prevHeight - adY;
				newY = prevY + adY;

				newY = newY - ((newWidth / prevWidth * prevHeight) - newHeight)
				newHeight = newWidth / prevWidth * prevHeight;

				tempX = (newX) - (newX + newWidth / 2);
				tempY = (newY) - (newY + newHeight / 2);

				if (!this.cornerResize) {
					tempX -= (newWidth - prevWidth) / 2
					tempY += (newHeight - prevHeight) / 2
				}

				rotatedX = tempX * Math.cos(angle * (Math.PI / 180)) - tempY * Math.sin(angle * (Math.PI / 180));
				rotatedY = tempX * Math.sin(angle * (Math.PI / 180)) + tempY * Math.cos(angle * (Math.PI / 180));

				r1Px = (newX) + (rotatedX + (newWidth / 2));
				r1Py = (newY) + (rotatedY + (newHeight / 2));

				newX = prevX - (rPx - r1Px);
				newY = prevY - (rPy - r1Py);
				break;
			case "right":
				newWidth = prevWidth + adX;
				tempX = (newX) - (newX + newWidth / 2);
				tempY = (newY) - (newY + newHeight / 2);

				if (!this.cornerResize) {
					tempX += (newWidth - prevWidth) / 2
					tempY += (newHeight - prevHeight) / 2
				}

				rotatedX = tempX * Math.cos(angle * (Math.PI / 180)) - tempY * Math.sin(angle * (Math.PI / 180));
				rotatedY = tempX * Math.sin(angle * (Math.PI / 180)) + tempY * Math.cos(angle * (Math.PI / 180));

				r1Px = (newX) + (rotatedX + (newWidth / 2));
				r1Py = (newY) + (rotatedY + (newHeight / 2));

				newX = prevX - (r1Px - rPx);
				newY = prevY - (r1Py - rPy);

				break;
			case "bottom-right":
				newWidth = prevWidth + adX;
				newHeight = prevHeight + adY;
				newHeight = newWidth / prevWidth * prevHeight;

				tempX = (newX) - (newX + newWidth / 2);
				tempY = (newY) - (newY + newHeight / 2);

				if (!this.cornerResize) {
					tempX += (newWidth - prevWidth) / 2
					tempY += (newHeight - prevHeight) / 2
				}

				rotatedX = tempX * Math.cos(angle * (Math.PI / 180)) - tempY * Math.sin(angle * (Math.PI / 180));
				rotatedY = tempX * Math.sin(angle * (Math.PI / 180)) + tempY * Math.cos(angle * (Math.PI / 180));

				r1Px = (newX) + (rotatedX + (newWidth / 2));
				r1Py = (newY) + (rotatedY + (newHeight / 2));

				newX = prevX - (r1Px - rPx);
				newY = prevY - (r1Py - rPy);
				break;
			case "bottom":
				newHeight = prevHeight + adY;

				tempX = (newX) - (newX + newWidth / 2);
				tempY = (newY) - (newY + newHeight / 2);

				if (!this.cornerResize) {
					tempX += (newWidth - prevWidth) / 2
					tempY += (newHeight - prevHeight) / 2
				}

				rotatedX = tempX * Math.cos(angle * (Math.PI / 180)) - tempY * Math.sin(angle * (Math.PI / 180));
				rotatedY = tempX * Math.sin(angle * (Math.PI / 180)) + tempY * Math.cos(angle * (Math.PI / 180));

				r1Px = (newX) + (rotatedX + (newWidth / 2));
				r1Py = (newY) + (rotatedY + (newHeight / 2));

				newX = prevX - (r1Px - rPx);
				newY = prevY - (r1Py - rPy);
				break;
			case "bottom-left":
				newWidth = prevWidth - adX;
				newHeight = prevHeight + adY;
				newX = prevX + adX;

				newHeight = newWidth / prevWidth * prevHeight;

				tempX = (newX) - (newX + newWidth / 2);
				tempY = (newY) - (newY + newHeight / 2);

				if (!this.cornerResize) {
					tempX += (newWidth - prevWidth) / 2
					tempY += (newHeight - prevHeight) / 2
				}

				rotatedX = tempX * Math.cos(angle * (Math.PI / 180)) - tempY * Math.sin(angle * (Math.PI / 180));
				rotatedY = tempX * Math.sin(angle * (Math.PI / 180)) + tempY * Math.cos(angle * (Math.PI / 180));

				r1Px = (newX) + (rotatedX + (newWidth / 2));
				r1Py = (newY) + (rotatedY + (newHeight / 2));

				newX = prevX - (rPx - r1Px);
				newY = prevY - (r1Py - rPy);
				break;
			case "left":

				newWidth = prevWidth - adX;
				newX = prevX + adX;

				tempX = (newX) - (newX + newWidth / 2);
				tempY = (newY) - (newY + newHeight / 2);

				if (!this.cornerResize) {
					tempX += (newWidth - prevWidth) / 2
					tempY += (newHeight - prevHeight) / 2
				}

				rotatedX = tempX * Math.cos(angle * (Math.PI / 180)) - tempY * Math.sin(angle * (Math.PI / 180));
				rotatedY = tempX * Math.sin(angle * (Math.PI / 180)) + tempY * Math.cos(angle * (Math.PI / 180));

				r1Px = (newX) + (rotatedX + (newWidth / 2));
				r1Py = (newY) + (rotatedY + (newHeight / 2));

				newX = prevX - (rPx - r1Px);
				newY = prevY - (rPy - r1Py);
				break;

			default:
				break;
		}

		let new_cx = (newX + newWidth / 2);
		let new_cy = (newY + newHeight / 2);

		if (this.restrictBounds) {
			if (((newX + newWidth) >= this.props.workspaceWidth || newX >= this.props.workspaceWidth)) {
				let oldWidth = newWidth;
				let rX = (newX + newWidth) - this.props.workspaceWidth;
				newWidth -= rX * 2;
				new_cx = this.props.workspaceWidth - newWidth / 2;
				newHeight *= newWidth / oldWidth;
				newX = new_cx - newWidth / 2;
				newY = new_cy - newHeight / 2;
			}
			if ((newX <= 0 || newX + newWidth <= 0)) {
				let oldWidth = newWidth;
				newWidth += newX * 2;
				newHeight *= newWidth / oldWidth;
				newX = new_cx - newWidth / 2;
				newY = new_cy - newHeight / 2;
			}
			if ((newY + newHeight >= this.props.workspaceHeight || newY >= this.props.workspaceHeight)) {

				let oldHeight = newHeight;
				let rY = (newY + newHeight) - this.props.workspaceHeight;
				newHeight -= rY * 2;
				new_cy = this.props.workspaceHeight - newHeight / 2;
				newWidth *= newHeight / oldHeight;
				newX = new_cx - newWidth / 2;
				newY = new_cy - newHeight / 2;
			}
			if ((newY <= 0 || newY + newHeight <= 0)) {

				let oldHeight = newHeight;
				newHeight += newY * 2;
				newWidth *= newHeight / oldHeight;
				newX = new_cx - newWidth / 2;
				newY = new_cy - newHeight / 2;
			}
		}


		let scale_x = (newWidth / this.initialSelectionBox.width);
		let scale_y = (newHeight / this.initialSelectionBox.height);


		return { scale_x: scale_x, scale_y: scale_y, cx: new_cx, cy: new_cy };
	} catch (error) {
		//Error Severity: LOW
		errorlog(error, error.message, "TransformManagerComponent-getResizePosition")
	}
	}

	getFontSize(text) {
		var container = document.getElementById(text.id);
		var ourText = container.getElementsByClassName("text-container")[0];
		if (ourText.style.fontSize === "")
			ourText.style.fontSize = "16px";
		var fontSize = parseFloat(ourText.style.fontSize, 10).toFixed(2);
		var maxHeight = text.height * this.props.zoomFactor;
		var textHeight = ourText.clientHeight, i, j;
		if (textHeight > maxHeight) {
			reached:
			for (i = 0; i < 500; i++) {
				if (textHeight < maxHeight) {
					fontSize = fontSize + 1
					for (j = 0; j < 10; j++) {
						let decFontSize = fontSize - ((j + 1) / 10);
						ourText.style.fontSize = decFontSize + "px";
						textHeight = ourText.clientHeight;
						if (textHeight <= maxHeight) {
							ourText.style.fontSize = decFontSize + "px";
							return decFontSize + "px";
							break reached;
						}
					}
					ourText.style.fontSize = fontSize + "px";
					return fontSize + "px";
					break;
				}
				fontSize--;
				ourText.style.fontSize = fontSize + "px";
				textHeight = ourText.clientHeight;
			}
		} else if (textHeight >0 && textHeight < maxHeight) {
			reached:
			for (i = 0; i < 500; i++) {
				if (textHeight > maxHeight) {
					for (j = 0; j < 10; j++) {
						let decFontSize = fontSize - ((j + 1) / 10);
						ourText.style.fontSize = decFontSize + "px";
						textHeight = ourText.clientHeight;
						if (textHeight <= maxHeight) {
							ourText.style.fontSize = decFontSize + "px";
							return decFontSize + "px";
							break reached;
						}
					}
					fontSize = fontSize - 1;
					ourText.style.fontSize = fontSize + "px";
					return fontSize + "px";
					break;
				}
				fontSize++;
				ourText.style.fontSize = fontSize + "px";
				textHeight = ourText.clientHeight;
			}
		}
		else {
			return ourText.style.fontSize + "px";
		}
	}

	updateResizeValues(e) {
		try {
		this.setCursor(e);
		let handle = this.initialSelectionBox.handle;
		let selectedId = this.selectedItems.keySeq().toArray()[0];
		if (this.isTextOnly()) {
			let textBounds = this.getTextBounds(e, selectedId);

			this.updateInitialSelectionBox({ transforming: false, resizing: false, x: textBounds.x, y: textBounds.y, width: textBounds.width, height: textBounds.height, cx: textBounds.x + textBounds.width / 2, cy: textBounds.y + textBounds.height / 2 });

			this.selectedItems = this.selectedItems.set(selectedId, this.selectedItems.get(selectedId).merge(fromJS(textBounds)));

			if (handle !== "left" && handle !== "right") {
				let fontSize = parseFloat(this.getFontSize({ id: this.props.textStatus.get("id"), width: textBounds.width - this.props.textOffset, height: textBounds.height - this.props.textOffset }), 10);

				this.selectedItems = this.selectedItems.setIn([selectedId, "textData", "formats", "containerStyle", "fontSize"], (fontSize / this.props.zoomFactor).toFixed(2) + "px");

			}

				this.props.resizeUpdate({ "items": this.selectedItems, "children": this.groupedItems, "selectedScene": this.props.selectedScene, "currentContainer": this.currentItemContainer, selectedItems: this.props.selectedItems, anchorScales: this.anchorScales }, this.props.socket);
		} else {
			let resize_position = this.getResizePosition(e);
			var scale_x = resize_position.scale_x, scale_y = resize_position.scale_y, cx = resize_position.cx, cy = resize_position.cy, new_width = Math.abs(this.initialSelectionBox.width * scale_x), new_height = Math.abs(this.initialSelectionBox.height * scale_y), new_x = cx - new_width / 2, new_y = cy - new_height / 2;

			this.updateInitialSelectionBox({ transforming: false, resizing: false, x: new_x, y: new_y, width: new_width, height: new_height, cx: new_x + new_width / 2, cy: new_y + new_height / 2 });
			var allItems = this.selectedItems;

			this.selectedItems.entrySeq().forEach(([key, item]) => {
				var item_width = Math.abs(item.get("width") * scale_x), item_height = Math.abs(item.get("height") * scale_y);

				var item_x = Math.cos((item.get("angle_to_center") + this.initialSelectionBox.angle) * Math.PI / 180) * Math.abs(item.get("dis_to_center") * scale_x) + cx - item_width / 2;
				var item_y = Math.sin((item.get("angle_to_center") + this.initialSelectionBox.angle) * Math.PI / 180) * Math.abs(item.get("dis_to_center") * scale_y) + cy - item_height / 2;
				let item_to_update = Map({ "x": item_x, "y": item_y, "width": item_width, "height": item_height });

				if (item.get("type") === "GROUP") {
					let groupItems = this.props.selectedChildren;

					item.get("groupChildren").entrySeq().forEach(([childKey, itemId]) => {

						let child = groupItems.get(itemId);
						let childWidth = Math.abs(child.get("width") * scale_x), childHeight = Math.abs(child.get("height") * scale_y);
						let groupedItem = this.groupedItems.get(itemId);

						var childGX = Math.cos((groupedItem.get("angle_to_center") + item.get("angle")) * Math.PI / 180) * Math.abs(groupedItem.get("dis_to_center") * scale_x) + (item_x + item_width / 2) - childWidth / 2;
						var childGY = Math.sin((groupedItem.get("angle_to_center") + item.get("angle")) * Math.PI / 180) * Math.abs(groupedItem.get("dis_to_center") * scale_y) + (item_y + item_height / 2) - childHeight / 2;

						let childToUpdate = Map({ "x": parseFloat(childGX.toFixed(2) + item_x.toFixed(2)), "y": parseFloat(childGY.toFixed(2) + item_x.toFixed(2)), "height": childHeight });

						if (item.get("subType") === "TXTGRP" && item.get("isExpands")) {
							var svgItem = groupItems.filter(function (obj, key) { return item.get("groupChildren").indexOf(key) !== -1 }).find(x => x.get("type") === "OVLYSVG");
							let xScale = scale_x;
							if (handle === "left" || handle === "right")
								xScale = 1;

							if (child.get("type") === "TEXT") {
								childToUpdate = childToUpdate.set("width", (item_width - (svgItem.getIn(["groupBounds", "leftItem", "width"]) * svgItem.getIn(["groupBounds", "leftItem", "scaleX"]) * xScale) - (svgItem.getIn(["groupBounds", "rightItem", "width"]) * svgItem.getIn(["groupBounds", "rightItem", "scaleX"]) * xScale)));

								childToUpdate = childToUpdate.set("x", item_x + (svgItem.getIn(["groupBounds", "leftItem", "width"]) * svgItem.getIn(["groupBounds", "leftItem", "scaleX"]) * xScale));
							}
							else {
								childToUpdate = childToUpdate.set("x", parseFloat(childGX.toFixed(2) + item_x.toFixed(2)));
								childToUpdate = childToUpdate.set("width", childWidth);
							}
						}
						else {
							childToUpdate = childToUpdate.set("x", parseFloat(childGX.toFixed(2) + item_x.toFixed(2)));
							childToUpdate = childToUpdate.set("width", childWidth);
						}

						if (child.get("type") === "TEXT" || child.get("type") === "SHAPE") {

							if (this.isFontAutoSize(itemId, "workspaceChildren") || (handle === "top-left" || handle === "top-right" || handle === "bottom-left" || handle === "bottom-right")) {
								let widthRatio = child.get("widthRatio") !== undefined && child.get("widthRatio") !== null ? Math.round(child.get("widthRatio")) : (child.get("type") === "SHAPE") ? 90 : 100;
								let heightRatio = child.get("heightRatio") !== undefined && child.get("heightRatio") !== null ? Math.round(child.get("heightRatio")) : (child.get("type") === "SHAPE") ? 90 : 100;

								let textWidth = (widthRatio / 100) * childWidth;
								let textHeight = (heightRatio / 100) * childHeight;
								if (child.get("type") !== "SHAPE" && item.get("subType") !== "TXTGRP") {
									textWidth -= this.props.textOffset;
									textHeight -= this.props.textOffset;
								}
								let fontSize = parseFloat(this.getFontSize({ id: itemId, width: textWidth, height: textHeight, isGrouped: true, parentId: key }), 10);

								childToUpdate = childToUpdate.set("textData", child.setIn(["textData", "formats", "containerStyle", "fontSize"], (fontSize / this.props.zoomFactor).toFixed(2) + "px").get("textData"));
							}
						}

						if (child.get("type") === "SHAPE") {
							let currentItem = child.set("width", childWidth).set("height", childHeight);
							var pathDetails = getPath(currentItem, this.props.zoomFactor, child);
							let pathData = childToUpdate.get("pathData") !== undefined ? childToUpdate.get("pathData").merge(fromJS(pathDetails.pathData)) : fromJS(pathDetails.pathData);
							childToUpdate = childToUpdate.set("pathData", pathData);

							let dataPath = getPath(currentItem, 1, child).pathDetails;
							childToUpdate = childToUpdate.set("path", fromJS(dataPath));
						}

						this.groupedItems = this.groupedItems.set(itemId, groupedItem.merge(childToUpdate));
					})

				}

				if (item.get("type") === "SHAPE") {

					let currentItem = item.set("width", item_width).set("height", item_height);
					var pathDetails = getPath(currentItem, 1, item);

					let dataPath = pathDetails.pathDetails;
					item_to_update = item_to_update.set("path", fromJS(dataPath));
				}
				if ((item.get("type") === "TEXT" || (item.get("type") === "SHAPE"))) {
					let textWidth = item_width;
					let textHeight = item_height;
					if (item.get("type") !== "SHAPE") {
						textWidth -= this.props.textOffset;
						textHeight -= this.props.textOffset;
					} else {
						let widthRatio = item.get("widthRatio") !== undefined && item.get("widthRatio") !== null ? Math.round(item.get("widthRatio")) : 90;
						let heightRatio = item.get("heightRatio") !== undefined && item.get("heightRatio") !== null ? Math.round(item.get("heightRatio")) : 90;

						textWidth = (widthRatio / 100) * textWidth;
						textHeight = (heightRatio / 100) * textHeight;

					}
					let fontSize = parseFloat(this.getFontSize({ id: key, width: textWidth, height: textHeight }), 10);
						if (this.isFontAutoSize(key) || (handle === "top-left" || handle === "top-right" || handle === "bottom-left" || handle === "bottom-right") || item.get("type") === "SHAPE") {
							if(!isNaN(fontSize))
							item_to_update = item_to_update.set("textData", item.setIn(["textData", "formats", "containerStyle", "fontSize"], (fontSize / this.props.zoomFactor).toFixed(2) + "px").get("textData"));
						}
				}
				allItems = allItems.set(key, item.merge(item_to_update));
			});
			this.selectedItems = allItems;




				this.props.resizeUpdate({
					"items": this.selectedItems,
					"children": this.groupedItems,
					"selectedScene": this.props.selectedScene,
					"currentContainer": this.currentItemContainer,
					selectedItems: this.props.selectedItems,
					anchorScales: this.anchorScales,
					isShapeOnly: this.isShapeOnly()
				}, this.props.socket);

		}
	} catch (error) {
		//Error Severity: LOW
		errorlog(error, error.message, "TransformManagerComponent-updateResizeValues")
	}
	}

	initiateResize(e) {
		try {
		e.preventDefault();

		this.scaleX = 1; this.scaleY = 1;
		let isResizeLocked = (this.lockResize !== undefined && this.lockResize) ? true : false;
		if (!isResizeLocked) {

			let handle = e.target.getAttribute("data-handle");
			if (this.isTextOnly() && (handle === "top-left" || handle === "top-right" || handle === "bottom-left" || handle === "bottom-right")) {
				this.cornerResize = true;
			}

			var corner_x = this.selectionBox.x, corner_y = this.selectionBox.y, center_x = this.selectionBox.cx, center_y = this.selectionBox.cy,
				width = this.selectionBox.width, height = this.selectionBox.height;

			if (!this.cornerResize) {
				corner_x = corner_x + width / 2;
				corner_y = corner_y + height / 2;
			}
			else {

				if (handle === "top-right")
					corner_y = corner_y + height;
				else if (handle === "top-left") {
					corner_y = corner_y + height;
					corner_x = corner_x + width;
				}
				else if (handle === "bottom-left")
					corner_x = corner_x + width;
				else if (handle === "right") {
					corner_y = corner_y + height / 2;
				}
				else if (handle === "left") {
					corner_x = corner_x + width;
					corner_y = corner_y + height / 2;
				}
				else if (handle === "top") {
					corner_y = corner_y + height;
					corner_x = corner_x + width / 2;
				}
				else if (handle === "bottom")
					corner_x = corner_x + width / 2;
			}



			let distance = Math.sqrt((Math.pow(center_x - corner_x, 2)) + (Math.pow(center_y - corner_y, 2))), angle_to_center = Math.atan2(center_y - corner_y, center_x - corner_x) * (180 / Math.PI), angle_to_corner = Math.atan2(corner_y - center_y, corner_x - center_x) * (180 / Math.PI);

			var tempX = this.selectionBox.x - (this.selectionBox.x + this.selectionBox.width / 2);
			var tempY = this.selectionBox.y - (this.selectionBox.y + this.selectionBox.height / 2);

			// now apply rotation
			var rotatedX = tempX * Math.cos(this.selectionBox.angle * (Math.PI / 180)) - tempY * Math.sin(this.selectionBox.angle * (Math.PI / 180));
			var rotatedY = tempX * Math.sin(this.selectionBox.angle * (Math.PI / 180)) + tempY * Math.cos(this.selectionBox.angle * (Math.PI / 180));

			// translate back
			var rPx = this.selectionBox.x + (rotatedX + (this.selectionBox.width / 2));
			var rPy = this.selectionBox.y + (rotatedY + (this.selectionBox.height / 2));

			this.updateInitialSelectionBox({ transforming: true, resizing: true, handle: handle, distance: distance, angle_to_center: angle_to_center, angle_to_corner: angle_to_corner, rotated_x: rPx, rotated_y: rPy });

				this.props.updateTransformStatus({ transforming: true, resizing: true });

			let mouse_position = this.getMousePosition(e);
			this.mouseStartPosition = Object.assign(this.mouseStartPosition, { x: mouse_position.x, y: mouse_position.y });

			if (this.isTextOnly())
				window.addEventListener('mousemove', this.resizeTextContainer, false);
			else
				window.addEventListener('mousemove', this.resizeSelection, false);

			window.addEventListener('mouseup', this.stopResize, false);
		}
	} catch (error) {
		//Error Severity: LOW
		errorlog(error, error.message, "TransformManagerComponent-initiateResize")
	}
	}

	resizeSelection(e) {
		try {
		e.preventDefault();
		let resize_position = this.getResizePosition(e);
		
		var scale_x = resize_position.scale_x, scale_y = resize_position.scale_y, cx = resize_position.cx, cy = resize_position.cy, new_width = Math.abs(this.initialSelectionBox.width * scale_x), new_height = Math.abs(this.initialSelectionBox.height * scale_y);
		let handle = this.selectionBox.handle;

		let selectionX = parseFloat(((cx - new_width / 2) * this.props.zoomFactor).toFixed(2)),
			selectionY = parseFloat(((cy - new_height / 2) * this.props.zoomFactor).toFixed(2)),
			selectionWidth = parseFloat((new_width * this.props.zoomFactor).toFixed(2)), selectionHeight = parseFloat((new_height * this.props.zoomFactor).toFixed(2));

		var selectionBox = this.selectionBoxElement;
		selectionBox.style.transform = "translate(" + selectionX + "px, " + selectionY + "px) rotateZ(" + this.selectionBox.angle + "deg)";
		selectionBox.style.width = selectionWidth + "px";
		selectionBox.style.height = selectionHeight + "px";

		if (selectionWidth < 60) {
			if (document.querySelector(".resize-handle.top").className.indexOf("hide-handle") === -1) {
				document.querySelector(".resize-handle.top").classList.add("hide-handle");
			}
			if (document.querySelector(".resize-handle.bottom").className.indexOf("hide-handle") === -1) {
				document.querySelector(".resize-handle.bottom").classList.add("hide-handle");
			}
		} else {
			if (document.querySelector(".resize-handle.top").className.indexOf("hide-handle") !== -1) {
				document.querySelector(".resize-handle.top").classList.remove("hide-handle");
			}
			if (document.querySelector(".resize-handle.bottom").className.indexOf("hide-handle") !== -1) {
				document.querySelector(".resize-handle.bottom").classList.remove("hide-handle");
			}
		}

		if (selectionHeight < 60) {
			if (document.querySelector(".resize-handle.left").className.indexOf("hide-handle") === -1) {
				document.querySelector(".resize-handle.left").classList.add("hide-handle");
			}
			if (document.querySelector(".resize-handle.right").className.indexOf("hide-handle") === -1) {
				document.querySelector(".resize-handle.right").classList.add("hide-handle");
			}
		} else {
			if (document.querySelector(".resize-handle.left").className.indexOf("hide-handle") !== -1) {
				document.querySelector(".resize-handle.left").classList.remove("hide-handle");
			}
			if (document.querySelector(".resize-handle.right").className.indexOf("hide-handle") !== -1) {
				document.querySelector(".resize-handle.right").classList.remove("hide-handle");
			}
		}

			this.selectedItems.entrySeq().forEach(([key, item]) => {

				var item_width = Math.abs(item.get("width") * scale_x), item_height = Math.abs(item.get("height") * scale_y);


				var item_x = Math.cos((item.get("angle_to_center") + this.initialSelectionBox.angle) * Math.PI / 180) * Math.abs(item.get("dis_to_center") * scale_x) + cx - item_width / 2;
				var item_y = Math.sin((item.get("angle_to_center") + this.initialSelectionBox.angle) * Math.PI / 180) * Math.abs(item.get("dis_to_center") * scale_y) + cy - item_height / 2;

				let current_item = document.getElementById(key);
				let flipPos = item.get("flipPosition");
				let flip = (flipPos === 1) ? " scaleX(-1)" : (flipPos === 2) ? " scaleY(-1)" : (flipPos === 3) ? " scaleX(-1) scaleY(-1)" : "";
				current_item.style.transform = "translate(" + (item_x * this.props.zoomFactor).toFixed(2) + "px, " + (item_y * this.props.zoomFactor).toFixed(2) + "px) rotateZ(" + item.get("angle") + "deg)" + flip;

				current_item.style.width = item_width * this.props.zoomFactor + "px";
				current_item.style.height = item_height * this.props.zoomFactor + "px";

				let groupFontSize = null;
				let textOffset = this.props.textOffset;

				if (item.get("type") === "GROUP") {

					if (item.get("subType") === "TXTGRP")
						textOffset = 0;

					item.get("groupChildren").entrySeq().forEach(([childKey, itemId]) => {
						let groupItems = this.props.selectedChildren;
						let child = groupItems.get(itemId);

						let childWidth = Math.abs(child.get("width") * scale_x), childHeight = Math.abs(child.get("height") * scale_y);
						let groupedItem = this.groupedItems.get(itemId);
						var childX = Math.cos((groupedItem.get("angle_to_center") + item.get("angle")) * Math.PI / 180) * Math.abs(groupedItem.get("dis_to_center") * scale_x) + (item_x + item_width / 2) - childWidth / 2;
						var childY = Math.sin((groupedItem.get("angle_to_center") + item.get("angle")) * Math.PI / 180) * Math.abs(groupedItem.get("dis_to_center") * scale_y) + (item_y + item_height / 2) - childHeight / 2;

						let currentChildItem = document.getElementById(itemId);


						let flipPos = child.get("flipPosition");
						let flip = (flipPos === 1) ? " scaleX(-1)" : (flipPos === 2) ? " scaleY(-1)" : (flipPos === 3) ? " scaleX(-1) scaleY(-1)" : "";

						let transform = "translate(" + (childX.toFixed(2) - item_x.toFixed(2)) * this.props.zoomFactor + "px, " + (childY.toFixed(2) - item_y.toFixed(2)) * this.props.zoomFactor + "px) rotateZ(" + child.get("angle") + "deg)" + flip;
						currentChildItem.style.transform = transform;
						currentChildItem.style.width = childWidth * this.props.zoomFactor + "px";
						currentChildItem.style.height = childHeight * this.props.zoomFactor + "px";

						if (child.get("type") === "TEXT" || child.get("type") === "SHAPE") {
							var container = document.getElementById(itemId);

							if (child.get("type") === "SHAPE") {
								container = container.getElementsByClassName("callout-text-container")[0];
								let xRatio = child.get("xRatio") !== undefined && child.get("xRatio") !== null ? child.get("xRatio") : 10;
								let yRatio = child.get("yRatio") !== undefined && child.get("yRatio") !== null ? child.get("yRatio") : 10;
								let widthRatio = child.get("widthRatio") !== undefined && child.get("widthRatio") !== null ? child.get("widthRatio") : 90;
								let heightRatio = child.get("heightRatio") !== undefined && child.get("heightRatio") !== null ? child.get("heightRatio") : 90;

								container.style.transform = "translate(" + ((childWidth * xRatio * this.props.zoomFactor) / 100) + "px, " + ((childHeight * yRatio * this.props.zoomFactor) / 100) + "px)" + flip;
								container.style.width = ((childWidth * widthRatio * this.props.zoomFactor) / 100) + "px";
								container.style.height = ((childHeight * heightRatio * this.props.zoomFactor) / 100) + "px";
							}

							if (this.isFontAutoSize(itemId, "workspaceChildren") || (handle === "top-left" || handle === "top-right" || handle === "bottom-left" || handle === "bottom-right")) {
								let fontSize = parseFloat(child.getIn(["textData", "formats", "containerStyle", "fontSize"]));

								var ourText = container.getElementsByClassName("text-container")[0];
								if (child.get("type") === "SHAPE")
									textOffset = 0;
								else if (item.get("subType") !== "TXTGRP")
									textOffset = this.props.textOffset;
								let tsx = (childWidth - textOffset) / child.get("width"), tsy = (childHeight - textOffset) / child.get("height");
								var scaledFontsize = Math.abs((fontSize * (tsx + tsy) / 2));
								ourText.style.fontSize = (scaledFontsize * this.props.zoomFactor) + "px";
								if (scaledFontsize > groupFontSize || groupFontSize === null)
									groupFontSize = scaledFontsize;
								if (this.props.textStatus.get("isFocused") && this.props.textStatus.get("id") === itemId) {
									this.props.updateTextStatus({ fontSize: (scaledFontsize).toFixed(2) });
								}
							}
						}

						if (((child.get("type") === "IMG" || child.get("type") === "STOCKIMG") && child.get("isCropped")) || child.get("type") === "FRAME") {
							let cropImageElem = document.getElementById(itemId).getElementsByTagName("img")[0];
							cropImageElem.style.left = ((child.getIn(["original", "x"]) * childWidth) * this.props.zoomFactor) + "px";
							cropImageElem.style.top = ((child.getIn(["original", "y"]) * childHeight) * this.props.zoomFactor) + "px";
							cropImageElem.style.width = ((child.getIn(["original", "width"]) * childWidth) * this.props.zoomFactor) + "px";
							cropImageElem.style.height = ((child.getIn(["original", "height"]) * childHeight) * this.props.zoomFactor) + "px";
						}

						if (child.get("type") === "SHAPE" && child.get("subType") === "CSTMPTH") {
							let currentItem = child.set("width", childWidth).set("height", childHeight);

							var pathDetails = getPath(currentItem, this.props.zoomFactor, child);
							let dataPath = pathDetails.pathDetails;
							if (Array.isArray(dataPath)) {
								for (let p = 0; p < dataPath.length; p++) {
									document.getElementById(itemId).getElementsByTagName("svg")[0].getElementsByClassName("path" + p)[0].setAttribute("d", dataPath[p].data);

									if (dataPath[p].pathStyle !== undefined)
										document.getElementById(itemId).getElementsByTagName("svg")[0].getElementsByTagName("g")[0].style.transform = "translate(" + dataPath[p].pathStyle.left + "px, " + dataPath[p].pathStyle.top + "px)";
								}
							}
						}

					});

					if (this.props.textStatus.get("isSelected") && this.props.textStatus.get("isGrouped") && this.props.textStatus.get("id") === key && groupFontSize !== null) {
						this.props.updateTextStatus({ fontSize: groupFontSize.toFixed(2) });
					}
				}

				if ((item.get("type") === "TEXT" || (item.get("type") === "SHAPE"))) {

					var container = document.getElementById(key);

					if (item.get("type") === "SHAPE") {
						let xRatio = item.get("xRatio") !== undefined && item.get("xRatio") !== null ? item.get("xRatio") : 10;
						let yRatio = item.get("yRatio") !== undefined && item.get("yRatio") !== null ? item.get("yRatio") : 10;
						let widthRatio = item.get("widthRatio") !== undefined && item.get("widthRatio") !== null ? item.get("widthRatio") : 90;
						let heightRatio = item.get("heightRatio") !== undefined && item.get("heightRatio") !== null ? item.get("heightRatio") : 90;
						container = container.getElementsByClassName("callout-text-container")[0];


						if (item.get("subType") === "CSTMPTH") {
							let currentItem = item.set("width", item_width).set("height", item_height);

							var pathDetails = getPath(currentItem, this.props.zoomFactor, item);
							let dataPath = pathDetails.pathDetails;
							if (Array.isArray(dataPath)) {
								for (let p = 0; p < dataPath.length; p++) {
									document.getElementById(key).getElementsByTagName("svg")[0].getElementsByClassName("path" + p)[0].setAttribute("d", dataPath[p].data);

									if (dataPath[p].pathStyle !== undefined)
										document.getElementById(key).getElementsByTagName("svg")[0].getElementsByTagName("g")[0].style.transform = "translate(" + dataPath[p].pathStyle.left + "px, " + dataPath[p].pathStyle.top + "px)";
								}
							}

							let flipPos = item.get("flipPosition");
							let flip = (flipPos === 1) ? " scaleX(-1)" : (flipPos === 2) ? " scaleY(-1)" : (flipPos === 3) ? " scaleX(-1) scaleY(-1)" : "";

							container.style.transform = "translate(" + ((item_width * xRatio * this.props.zoomFactor) / 100) + "px, " + ((item_height * yRatio * this.props.zoomFactor) / 100) + "px)" + flip;
							container.style.width = ((item_width * widthRatio * this.props.zoomFactor) / 100) + "px";
							container.style.height = ((item_height * heightRatio * this.props.zoomFactor) / 100) + "px";


							if (pathDetails.shapeStyle !== undefined) {
								document.getElementById(key).getElementsByTagName("svg")[0].style.left = pathDetails.shapeStyle.left;
								document.getElementById(key).getElementsByTagName("svg")[0].style.top = pathDetails.shapeStyle.top;
								document.getElementById(key).getElementsByTagName("svg")[0].style.width = pathDetails.shapeStyle.width;
								document.getElementById(key).getElementsByTagName("svg")[0].style.height = pathDetails.shapeStyle.height;
							}

							if (item.get("subType") === "CSTMPTH" && this.selectedItems.size === 1) {
								let pathData = fromJS(pathDetails.pathData);
								if (pathDetails.newControlPoints !== undefined) {
									let newControlPoints = this.getFlipPosition(pathDetails.newControlPoints, item.get("flipPosition"));
									for (let p in newControlPoints) {
										document.getElementsByClassName("control-point " + p)[0].style.left = "calc(" + newControlPoints[p].x + "% - 7.5px)";
										document.getElementsByClassName("control-point " + p)[0].style.top = "calc(" + newControlPoints[p].y + "% - 7.5px)";
									}
								}

								else if (pathData) {
									pathData.get("controlPoints").entrySeq().forEach(([key, pos]) => {
										document.getElementsByClassName("control-point " + key)[0].style.left = "calc(" + pos.get("x") + "% - 7.5px)";
										document.getElementsByClassName("control-point " + key)[0].style.top = "calc(" + pos.get("y") + "% - 7.5px)";
									});
								}
							}
						}

					}

					if ((this.isFontAutoSize(key) || (handle === "top-left" || handle === "top-right" || handle === "bottom-left" || handle === "bottom-right") || item.get("type") === "SHAPE")) {
						let fontSize = parseFloat(item.getIn(["textData", "formats", "containerStyle", "fontSize"]), 10);
						var ourText = container.getElementsByClassName("text-container")[0];

						if (item.get("type") === "SHAPE")
							textOffset = 0;
						let tsx = (item_width - textOffset) / item.get("width"), tsy = (item_height - textOffset) / item.get("height");

						ourText.style.fontSize = ((fontSize * Math.abs(Math.max(tsx, tsy))) * this.props.zoomFactor).toFixed(2) + "px";
						if ((this.props.textStatus.get("isSelected") || this.props.textStatus.get("isFocused")) && this.props.textStatus.get("id") === key) {
							if (document.getElementsByClassName("font-size-input")[0] !== undefined && document.getElementsByClassName("font-size-input")[0] !== null) {
								document.getElementsByClassName("font-size-input")[0].value = ((fontSize * Math.abs(Math.max(tsx, tsy))) * this.props.zoomFactor).toFixed(2);
							}
						}
					}
				}

				if (((item.get("type") === "IMG" || item.get("type") === "STOCKIMG") && item.get("isCropped")) || item.get("type") === "FRAME") {
					let cropImageElem = document.getElementById(key).getElementsByTagName("img")[0];
					cropImageElem.style.left = ((item.getIn(["original", "x"]) * item_width) * this.props.zoomFactor) + "px";
					cropImageElem.style.top = ((item.getIn(["original", "y"]) * item_height) * this.props.zoomFactor) + "px";
					cropImageElem.style.width = ((item.getIn(["original", "width"]) * item_width) * this.props.zoomFactor) + "px";
					cropImageElem.style.height = ((item.getIn(["original", "height"]) * item_height) * this.props.zoomFactor) + "px";
				}

			});
		} catch (error) {
			//Error Severity: LOW
			errorlog(error, error.message, "TransformManagerComponent-resizeSelection")
		}
	}

	stopResize(e) {
		try {
		e.preventDefault();
		if (!this.props.isToolCropping) {
			this.updateResizeValues(e);
		}
		else {
			let resize_position = this.getResizePosition(e);
			var scale_x = resize_position.scale_x, scale_y = resize_position.scale_y, cx = resize_position.cx, cy = resize_position.cy, new_width = Math.abs(this.initialSelectionBox.width * scale_x), new_height = Math.abs(this.initialSelectionBox.height * scale_y);
			let handle = this.selectionBox.handle;

			let selectionX = cx - new_width / 2,
				selectionY = cy - new_height / 2,
				selectionWidth = new_width, selectionHeight = new_height;

			let toUpdate = { x: selectionX / this.props.workspaceWidth, y: selectionY / this.props.workspaceHeight, width: selectionWidth / this.props.workspaceWidth, height: selectionHeight / this.props.workspaceHeight };
			this.props.updateBg({ selectedScene: this.props.selectedScene, toUpdate: toUpdate, toolCrop: true }, this.props.socket);
		}

		window.removeEventListener('mousemove', this.resizeSelection, false);
		window.removeEventListener('mousemove', this.resizeTextContainer, false);
		window.removeEventListener('mouseup', this.stopResize, false);
		this.resetCursor(e);
	} catch (error) {
		//Error Severity: LOW
		errorlog(error, error.message, "TransformManagerComponent-stopResize")
	}
	}

	getQuadrant(_deg) {
		var r = 0;
		if (_deg >= 0 && _deg <= 90) {
			r = 1;
		} else if (_deg > 90 && _deg <= 180) {
			r = 2;
		} else if (_deg > 180 && _deg <= 270) {
			r = 3;
		} else if (_deg > 270 && _deg <= 360) {
			r = 4;
		}
		return r;
	}

	getAngle(e) {
		let workspaceBounds = this.getWorkspaceBounds();

		var angle = Math.atan2((e.clientY - workspaceBounds.y - (this.selectionBox.cy * this.props.zoomFactor)), e.clientX - workspaceBounds.x - (this.selectionBox.cx * this.props.zoomFactor)) * (180 / Math.PI);

		this.prevY = e.clientY - workspaceBounds.y; this.prevX = e.clientX - workspaceBounds.x;

		let rotation = angle - this.startAngle;
		var rAngle = rotation + this.initialSelectionBox.angle;

		if (rAngle < 0)
			rAngle += 360;

		let increements = 8;
		let snapAngle = 360 / increements;
		let snapPoint = 5;

		if (Math.abs(rAngle) % snapAngle < (snapPoint)) {
			rAngle -= (rAngle % snapAngle);

			document.getElementsByClassName("rotationLine")[0].style.left = (((this.selectionBox.x + this.selectionBox.width / 2) * this.props.zoomFactor) + workspaceBounds.x) + "px";
			document.getElementsByClassName("rotationLine")[0].style.top = (((this.selectionBox.y) * this.props.zoomFactor) + workspaceBounds.y) + "px";
			document.getElementsByClassName("rotationLine")[0].style.height = (this.selectionBox.height * this.props.zoomFactor) + "px";
			document.getElementsByClassName("rotationLine")[0].style.transform = "rotateZ(" + rAngle + "deg)";
			document.getElementsByClassName("rotationLine")[0].style.display = "block";
		} else {
			document.getElementsByClassName("rotationLine")[0].style.display = "none";
		}

		if (this.restrictBounds) {
			var bounds = this.getSelectionBoxBounds({ x: this.selectionBox.x, y: this.selectionBox.y, cx: this.selectionBox.cx, cy: this.selectionBox.cy, width: this.selectionBox.width, height: this.selectionBox.height, angle: rAngle });

			var x = bounds.x, y = bounds.y, sWidth = bounds.width, sHeight = bounds.height;

			x = (x < 0) ? 0 : x;
			y = (y < 0) ? 0 : y;

			let widthRestricted = ((x + sWidth) >= workspaceBounds.width) ? true : false;
			let heightRestricted = ((y + sHeight) >= workspaceBounds.height) ? true : false;

			if ((x === 0 || y === 0 || widthRestricted || heightRestricted)) {
				if (!this.restrictedSelectionBox.isRestricted) {
					Object.assign(this.restrictedSelectionBox, { isRestricted: true, angle: rAngle });
				}
				rAngle = this.restrictedSelectionBox.angle;
			}
			else if (this.restrictedSelectionBox.isRestricted) {
				Object.assign(this.restrictedSelectionBox, { isRestricted: false });
			}
		}

		let oldQuad = this.getQuadrant(this.angle);
		let newQuad = this.getQuadrant(rAngle);

		if (oldQuad !== newQuad) {
			if (newQuad - oldQuad === 1 || oldQuad - newQuad === 1) {
			} else {
				if (oldQuad === 4 && newQuad === 1) {
					this.rotateCount++;
				}
				else if (oldQuad === 1 && newQuad === 4) {
					this.rotateCount--;
				}
			}
		}

		this.angle = rAngle;

		return (Math.abs(this.angle) > 360) ? this.angle % 360 : this.angle;
	}

	initiateRotate(e) {
		try {
		e.preventDefault();
		let isRotateLocked = (this.lockRotate !== undefined && this.lockRotate) ? true : false;

		if (!isRotateLocked) {
			this.angle = this.selectionBox.angle;
			this.rotateCount = 0;

		
			let workspace_bounds = this.getWorkspaceBounds();

			let wpx = e.clientX - workspace_bounds.x, wpy = e.clientY - workspace_bounds.y, scx = this.selectionBox.cx * this.props.zoomFactor, scy = this.selectionBox.cy * this.props.zoomFactor;
			this.diffX = wpx; this.diffY = wpy;
			this.prevY = wpx; this.prevX = wpy;
			this.startAngle = Math.atan2((wpy - scy), (wpx - scx)) * (180 / Math.PI);

			this.updateInitialSelectionBox({ transforming: true, rotating: true, handle: e.target.getAttribute("data-handle") });


				this.props.updateTransformStatus({ transforming: true, rotating: true });

			document.getElementsByClassName("rotationDisplay")[0].style.left = (workspace_bounds.x + ((this.selectionBox.x + this.selectionBox.width / 2) * this.props.zoomFactor)) - 11 + "px";
			document.getElementsByClassName("rotationDisplay")[0].style.top = (workspace_bounds.y + ((this.selectionBox.y + this.selectionBox.height / 2) * this.props.zoomFactor)) - 11 + "px";
			document.getElementsByClassName("rotationDisplay")[0].style.display = "table";

			window.addEventListener('mousemove', this.rotateSelection, false);
			window.addEventListener('mouseup', this.stopRotate, false);
		}
	}  catch (error) {
		//Error Severity: LOW
		errorlog(error, error.message, "TransformManagerComponent-initiateRotate")
	}
	}

	rotateSelection(e) {
		try {
		e.preventDefault();
		var rAngle = this.getAngle(e);
		var angleDisplay = rAngle;
		if (angleDisplay > 180)
			angleDisplay = angleDisplay - 360;

		var selectionBox = this.selectionBoxElement;
		selectionBox.style.transform = "translate(" + this.selectionBox.x * this.props.zoomFactor + "px, " + this.selectionBox.y * this.props.zoomFactor + "px) rotateZ(" + rAngle + "deg)";
		document.getElementById("rotationAngle").innerText = Math.round(angleDisplay).toFixed(0);
		var allItems = this.selectedItems;
		rAngle = parseFloat(rAngle);

			this.selectedItems.entrySeq().forEach(([key, item]) => {
				let current_item = document.getElementById(key);
				let flipPos = item.get("flipPosition");
				let flip = (flipPos === 1) ? " scaleX(-1)" : (flipPos === 2) ? " scaleY(-1)" : (flipPos === 3) ? " scaleX(-1) scaleY(-1)" : "";
				let item_x = (Math.cos((item.get("angle_to_center") + rAngle) * Math.PI / 180) * item.get("dis_to_center") + this.selectionBox.cx) - item.get("width") / 2,
					item_y = (Math.sin((item.get("angle_to_center") + rAngle) * Math.PI / 180) * item.get("dis_to_center") + this.selectionBox.cy) - item.get("height") / 2;
				let initialAngle = parseFloat(this.state.selectedObjects.getIn([key, "angle"]));
				var item_angle = rAngle + initialAngle;

				if (allItems.size === 1)
					item_angle -= initialAngle;

				item_angle = (Math.abs(item_angle) > 360) ? item_angle % 360 : item_angle;

				current_item.style.transform = "translate(" + (item_x * this.props.zoomFactor).toFixed(4) + "px, " + (item_y * this.props.zoomFactor).toFixed(4) + "px) rotateZ(" + (item_angle) + "deg) " + flip;

				let item_to_update = Map({ "x": item_x, "y": item_y, "angle": item_angle, "rotationCount": this.rotateCount });

				allItems = allItems.set(key, item.merge(item_to_update));
			});

		this.selectedItems = allItems;
		} catch (error) {
			//Error Severity: LOW
			errorlog(error, error.message, "TransformManagerComponent-rotateSelection")
		}
	}

	stopRotate(e) {
		try {
		e.preventDefault();
		this.setCursor(e);
		var rAngle = this.getAngle(e);

		document.getElementsByClassName("rotationDisplay")[0].style.display = "none";
		document.getElementsByClassName("rotationLine")[0].style.display = "none";
		this.updateInitialSelectionBox({ transforming: false, rotating: false, angle: rAngle });


			{
				let allChildrens = this.groupedItems;

				let allItems = this.selectedItems;
			}

			this.props.rotationUpdate({ "items": this.selectedItems, "children": this.groupedItems, "selectedScene": this.props.selectedScene, "currentContainer": this.currentItemContainer, selectedItems: this.props.selectedItems }, this.props.socket);
		window.removeEventListener('mousemove', this.rotateSelection, false);
		window.removeEventListener('mouseup', this.stopRotate, false);
		this.resetCursor(e);
		} catch (error) {
			//Error Severity: LOW
			errorlog(error, error.message, "TransformManagerComponent-stopRotate")
		}
	}

	isTextOnly() {
		var result = false;
		if (this.props.selectedItems.size === 1) {
			var itemType = this.props.selectedObjects.get(this.props.selectedItems.get(0));
			if (itemType !== undefined && itemType.get("type") === "TEXT" && itemType.get("subType") === "DTXT") {
				result = true;
			}
		}
		return result;
	}

	isCalloutOnly() {
		var result = false;
		if (this.props.selectedItems.size === 1) {
			var itemType = this.props.selectedObjects.get(this.props.selectedItems.get(0));
			if (itemType !== undefined && itemType.get("type") === "SHAPE") {
				result = true;
			}
		}
		return result;
	}

	isShapeOnly() {
		var result = false;
		if (this.props.selectedItems.size === 1) {
			var itemType = this.props.selectedObjects.get(this.props.selectedItems.get(0));
			if (itemType !== undefined && itemType.get("type") === "SHAPE") {
				result = true;
			}
		}
		return result;
	}

	isPermenantGroup() {
		if (this.props.selectedItems.size === 1) {
			if (this.props.selectedObjects.getIn([this.props.selectedItems.get(0), "type"]) === "GROUP") {
				return true;
			}
		}
		return false;
	}

	getCorner(pivotX, pivotY, cornerX, cornerY, angle) {
		var x, y, distance, diffX, diffY;

		/// get distance from center to point
		diffX = cornerX - pivotX;
		diffY = cornerY - pivotY;
		distance = Math.sqrt(diffX * diffX + diffY * diffY);

		/// find angle from pivot to corner
		angle += Math.atan2(diffY, diffX);

		/// get new x and y and round it off to integer
		x = pivotX + distance * Math.cos(angle);
		y = pivotY + distance * Math.sin(angle);

		return { x: x, y: y };
	}

	getSelectionBoxBounds(data) {
		var angle = data.angle * Math.PI / 180
		var c1, c2, c3, c4,    /// corners
			bx1, by1, bx2, by2, bounds;
		c1 = this.getCorner(data.cx, data.cy, data.x, data.y, angle);
		c2 = this.getCorner(data.cx, data.cy, data.x + data.width, data.y, angle);
		c3 = this.getCorner(data.cx, data.cy, data.x + data.width, data.y + data.height, angle);
		c4 = this.getCorner(data.cx, data.cy, data.x, data.y + data.height, angle);
		/// get bounding box
		bx1 = Math.min(c1.x, c2.x, c3.x, c4.x);
		by1 = Math.min(c1.y, c2.y, c3.y, c4.y);
		bx2 = Math.max(c1.x, c2.x, c3.x, c4.x);
		by2 = Math.max(c1.y, c2.y, c3.y, c4.y);

		bounds = { x: parseFloat(bx1.toFixed(2)), y: parseFloat(by1.toFixed(2)), width: parseFloat((bx2 - bx1).toFixed(2)), height: parseFloat((by2 - by1).toFixed(2)) };

		return bounds;
	}

	getObjectsBounds(objects) {
		var minX = 0, maxX = 0, minY = 0, maxY = 0;
		var count = 0;
		objects.entrySeq().forEach(([key, item]) => {
			let bounds, x, y, width, height;
			bounds = this.getSelectionBoxBounds({ x: item.get("x"), y: item.get("y"), cx: item.get("x") + item.get("width") / 2, cy: item.get("y") + item.get("height") / 2, width: item.get("width"), height: item.get("height"), angle: item.get("angle") });

			x = bounds.x; y = bounds.y; width = bounds.width; height = bounds.height;

			if (count === 0) {
				minX = x; maxX = x + width; minY = y; maxY = y + height;
				count++;
			} else {
				minX = Math.min(minX, x); maxX = Math.max(maxX, x + width); minY = Math.min(minY, y); maxY = Math.max(maxY, y + height);
			}
		});

		return { x: minX, y: minY, width: maxX - minX, height: maxY - minY }
	}

	setItemPositions(item) {
		let scx = this.selectionBox.cx, scy = this.selectionBox.cy, icx = (item.get("x") / this.props.zoomFactor) + (item.get("width") / this.props.zoomFactor) / 2, icy = (item.get("y") / this.props.zoomFactor) + (item.get("height") / this.props.zoomFactor) / 2;

		let item_angle = Math.atan2((icy * this.props.zoomFactor) - scy, (icx * this.props.zoomFactor) - scx) * (180 / Math.PI);

		let dis = Math.sqrt((Math.pow(scx - (icx * this.props.zoomFactor), 2)) + (Math.pow(scy - (icy * this.props.zoomFactor), 2)));

		let itemToMerge = Map({ "angle_to_center": item_angle, "dis_to_center": dis });


		if (item.get("type") === "GROUP") {
			let groupedCX = item.get("x") + item.get("width") / 2, groupedCY = item.get("y") + item.get("height") / 2;
			var groupItems = this.props.selectedChildren;
			let anchorAngles = {};
			item.get("groupChildren").entrySeq().forEach(([childKey, itemId]) => {

				let child = groupItems.get(itemId);
				let groupedItemCX = child.get("x") + child.get("width") / 2, groupedItemCY = child.get("y") + child.get("height") / 2;
				let childAngle = Math.atan2(groupedItemCY - groupedCY, groupedItemCX - groupedCX) * (180 / Math.PI) - item.get("angle");
				let childDis = Math.sqrt((Math.pow(groupedCX - groupedItemCX, 2)) + (Math.pow(groupedCY - groupedItemCY, 2)));
				let childToMerge = Map({ "angle_to_center": childAngle, "dis_to_center": childDis });

				this.groupedItems = this.groupedItems.set(itemId, child.merge(childToMerge));
			})
		}
		return item.merge(itemToMerge);
	}

	getSelectionBox() {

		var x = null, y = null, width = null, height = null, cx = null, cy = null, angle = 0;

		let selectedObjects = this.state.selectedObjects;
		this.selectedItems = this.state.selectedObjects;

		if (selectedObjects !== null && selectedObjects.size === 1) {

			let item = selectedObjects.first();
				x = item.get("x"); y = item.get("y"); width = item.get("width"); height = item.get("height"); angle = item.get("angle");

		} else {
			if (this.props.selectedTab === "cameraTab")
				this.selectedItems = this.props.selectedItems
			let bounds = this.getObjectsBounds(this.selectedItems);
			x = bounds.x; y = bounds.y; width = bounds.width; height = bounds.height;
		}

		if (x !== null)
			cx = x + (width / 2);
		if (y !== null)
			cy = y + (height / 2);
		if (angle === undefined)
			angle = 0;
		this.selectionBox = Object.assign(this.selectionBox, { x: x, y: y, width: width, height: height, cx: cx, cy: cy, angle: angle });
		this.initialSelectionBox = this.selectionBox;
		this.selectedItems = this.selectedItems.map(x => this.setItemPositions(x));
		var getAllItems = this.selectedItems;
		this.selectedItems.entrySeq().forEach(([key, single_item]) => {
			getAllItems = getAllItems.set(key, single_item.set("sAngle", single_item.get("angle") !== undefined ? single_item.get("angle") : 0));
		});
		this.selectedItems = getAllItems;

		return this.selectionBox;
	}

	isVerticalScale() {
		var result = false;
		if (this.props.selectedItems.size === 1) {
			var item = this.props.selectedObjects.get(this.props.selectedItems.get(0));
			if (item !== undefined) {
				if (item.get("type") === "GROUP" && item.get("subType") === "TXTGRP" && !item.get("isOverlay")) {
					if (item.get("isExpands")) {

						var svgItem = this.props.selectedChildren.filter(function (obj, key) { return item.get("groupChildren").indexOf(key) !== -1 }).find(x => x.get("type") === "TEXT");
						if (svgItem.get("verticalAlign") !== undefined)
							result = true;
					}

				}
				else if (item.get("type") === "SHAPE" || (item.get("type") === "TEXT")) {
					if (item.get("scaleType") === "square" || item.get("scaleType") === "vertical")
						return true;
					else
						return false;
				}
			}
		}
		return result;
	}

	isHorizontalScale() {
		var result = false;
		if (this.props.selectedItems.size === 1) {
			var item = this.props.selectedObjects.get(this.props.selectedItems.get(0));
			if (item !== undefined) {
				if (item.get("type") === "TEXT" && item.get("subType") === "DTXT") {
					result = true;
				}
				else if (item.get("type") === "GROUP" && item.get("subType") === "TXTGRP" && !item.get("isOverlay")) {
					if (item.get("isExpands")) {

						var svgItem = this.props.selectedChildren.filter(function (obj, key) { return item.get("groupChildren").indexOf(key) !== -1 }).find(x => x.get("type") === "TEXT");
						if (svgItem.get("horizontalAlign") !== undefined)
							result = true;
					}
				}
				else if (item.get("type") === "SHAPE" || (item.get("type") === "TEXT")) {

					if (item.get("scaleType") === "square" || item.get("scaleType") === "horizontal")
						return true;
					else
						return false;
				}
			}
		}
		return result;
	}

	getXYRotation(cx, cy, x, y, angle) {

		var x2 = Math.cos(angle / 180 * Math.PI) * (x - cx) - Math.sin(angle / 180 * Math.PI) * (y - cy);
		var y2 = Math.sin(angle / 180 * Math.PI) * (x - cx) + Math.cos(angle / 180 * Math.PI) * (y - cy);
		return [x2 + cx, y2 + cy];

	}


	dist(pot1, pt2) {
		var dx = pot1.x - pt2.x;
		var dy = pot1.y - pt2.y;
		return Math.sqrt(dx * dx + dy * dy);
	};

	getCubicBezierPoints(pointDataArr, t) {


		var helperPoints = [];

		for (var i = 1; i < 4; i++) {
			var p = this.lerp(pointDataArr[i - 1], pointDataArr[i], t);
			helperPoints.push(p);
		}

		helperPoints.push(this.lerp(helperPoints[0], helperPoints[1], t));
		helperPoints.push(this.lerp(helperPoints[1], helperPoints[2], t));


		helperPoints.push(this.lerp(helperPoints[3], helperPoints[4], t));

		let firstBezier = [
			pointDataArr[0],
			helperPoints[0],
			helperPoints[3],
			helperPoints[5]
		];
		let secondBezier = [
			helperPoints[5],
			helperPoints[4],
			helperPoints[2],
			pointDataArr[3]
		];

		// returns 2 array of points for the new bezier curves;
		return [firstBezier, secondBezier];
	}

	lerp(A, B, t) {

		return [
			(Number(B[0]) - Number(A[0])) * t + Number(A[0]), // the x coordinate;
			(Number(B[1]) - Number(A[1])) * t + Number(A[1])  // the y coordinate;
		];

	}
	sfix(arr) {
		var num1 = Number(arr[0]);
		var num2 = Number(arr[1]);
		num1 = num1 < 0 ? Math.floor(Math.abs(num1) * 100) * -1 / 100 : num1.toFixed(2);
		num2 = num2 < 0 ? Math.floor(Math.abs(num2) * 100) * -1 / 100 : num2.toFixed(2);
		return num1 + "," + num2
	}

	sFix2(num1, num2) {
		num1 = Number(num1);
		num2 = Number(num2);
		num1 = num1 < 0 ? Math.floor(Math.abs(num1) * 100) * -1 / 100 : num1.toFixed(2);
		num2 = num2 < 0 ? Math.floor(Math.abs(num2) * 100) * -1 / 100 : num2.toFixed(2);
		return num1 + "," + num2
	}

	drawTail(pathData, calloutPath, callout, dataArray, ptArray, xy, cTail, endPt, update) {

		var individualPtArray = dataArray;
		var plen2 = ptArray.length;
		let pt = calloutPath.getPointAtLength(cTail);
		let pt2 = calloutPath.getPointAtLength(endPt);
		var currentSegment1 = 0;
		var currentSegment2 = 0;

		for (var i = 0; i < plen2; i++) {
			if (cTail < ptArray[i].t) {
				currentSegment1 = i;
				break;
			}
		}

		for (var j = 0; j < plen2; j++) {
			if (endPt < ptArray[j].t) {
				currentSegment2 = j;
				break;
			}
		}

		var istr = ""
		var totalIndi = ((currentSegment1 + 1) * 3) + 1

		for (var v = 0; v < totalIndi - 3; v++) {


			istr = istr + individualPtArray[v] + " "
		}
		var cir2ptDataArr = []
		for (v = totalIndi - 4; v < totalIndi; v++) {

			if (individualPtArray[v].indexOf("C") !== -1) {
				cir2ptDataArr.push(individualPtArray[v].substring(1).split(","))
			} else {
				cir2ptDataArr.push(individualPtArray[v].split(","))
			}
		}

		var cir3ptDataArr = []

		var totalIndi2 = ((currentSegment2 + 1) * 3) + 1

		for (var d = totalIndi2 - 4; d < totalIndi2; d++) {

			if (individualPtArray[d].indexOf("C") !== -1) {
				cir3ptDataArr.push(individualPtArray[d].substring(1).split(","))
			} else {
				cir3ptDataArr.push(individualPtArray[d].split(","))
			}
		}

		var ustr = ""
		var totalInd = individualPtArray.length
		for (var u = totalIndi2 - 1; u < totalInd; u++) {
			ustr = ustr + individualPtArray[u] + " "
		}

		var curseg1 = currentSegment1
		var t
		if (currentSegment1 <= 0) {
			t = (cTail / ptArray[0].t)
		} else {
			t = ((cTail - ptArray[curseg1 - 1].t) / (ptArray[curseg1].t - ptArray[curseg1 - 1].t))

		}

		var resultcir2Arr = this.getCubicBezierPoints(cir2ptDataArr, t);


		var t2
		var curseg2 = currentSegment2
		if (currentSegment2 - 1 < 0) {
			t2 = (endPt / ptArray[0].t)
		} else {
			t2 = ((endPt - ptArray[curseg2 - 1].t) / (ptArray[curseg2].t - ptArray[curseg2 - 1].t))
		}


		var resultcir3Arr = this.getCubicBezierPoints(cir3ptDataArr, t2);


		var cl0 = this.sFix2(pt.x, pt.y)
		var cl = this.sFix2(xy.x, xy.y)
		var cl2 = this.sFix2(pt2.x, pt2.y)
		var h1 = this.sfix(resultcir2Arr[0][1])
		var h2 = this.sfix(resultcir2Arr[0][2])


		var b1 = this.sfix(resultcir3Arr[1][1])
		var b2 = this.sfix(resultcir3Arr[1][2]);
		var data = "M" + istr + "C" + h1 + " " + h2 + " " + cl0 + " C" + cl0 + " " + cl + " " + cl + " C" + cl + " " + cl2 + " " + cl2 + " C" + b1 + " " + b2 + " " + ustr;

		if (currentSegment2 >= currentSegment1) {
			// callout.setAttributeNS(null,'d',"M"+istr+"C"+h1+" "+h2+" "+cl0+" C"+cl0+" "+cl+" "+cl+" C"+cl+" "+cl2+" "+cl2+" C"+b1+" "+b2+" "+ustr);
		} else {
			var istrArr = istr.split(" ")
			istrArr.shift();
			istrArr.shift();
			istrArr.shift();
			istr = istrArr.join(" ")
			// callout.setAttributeNS(null,'d',"M"+cl2+" C"+b1+" "+	b2+" "+istr+"C"+h1+" "+h2+" "+cl0+" C"+cl0+" "+cl+" "+cl+" C"+cl+" "+cl2+" "+cl2);
			data = "M" + cl2 + " C" + b1 + " " + b2 + " " + istr + "C" + h1 + " " + h2 + " " + cl0 + " C" + cl0 + " " + cl + " " + cl + " C" + cl + " " + cl2 + " " + cl2;
			// callout.setAttributeNS(null,'d',"M"+istr+"C"+h1+" "+h2+" "+cl0+" C"+cl0+" "+cl+" "+cl+" C"+cl+" "+cl2+" "+cl2);
		}
		callout.setAttributeNS(null, 'd', data);
		if (update === true) {
			this.props.updateObjectById({ selectedScene: this.props.selectedScene, container: "workspaceItems", id: this.props.selectedItems.get(0), toUpdate: { path: [data] } }, this.props.socket);
		}
	}

	gradSearch(l0, pt) {
		l0 = l0 + this.actualLength;

		var l1 = l0,
			dist0 = this.dist(this.calloutPath.getPointAtLength(l0 % this.actualLength), pt),
			dist1,
			searchDir;
		if (this.dist(this.calloutPath.getPointAtLength((l0 - 1) % this.actualLength), pt) >
			this.dist(this.calloutPath.getPointAtLength((l0 + 1) % this.actualLength), pt)) {
			searchDir = 1;
		} else {
			searchDir = -1;
		}

		l1 += searchDir;
		dist1 = this.dist(this.calloutPath.getPointAtLength(l1 % this.actualLength), pt);
		while (dist1 < dist0) {
			dist0 = dist1;
			l1 += searchDir;
			dist1 = this.dist(this.calloutPath.getPointAtLength(l1 % this.actualLength), pt);
		}
		l1 -= searchDir;
		return (l1 % this.actualLength);
	}

	controlShape(e) {

		e.preventDefault();
		e.stopPropagation();
		var t = e.target, et = e.type, m = { x: e.pageX, y: e.pageY };

		if (et === "mousedown" || et === "touchstart") {
			if (!this.drag) {
				this.drag = t;
				this.dPoint = m;
				this.handle = e.target.getAttribute("datahandle");
				this.pathData = this.selectedItems.getIn([this.props.selectedItems.get(0), "pathData"]).toJS();

				this.moveType = this.pathData.controlPoints[this.handle].moveType;
				this.angle = this.selectedItems.getIn([this.props.selectedItems.get(0), "angle"]);

				this.prevX = ((this.pathData.controlPoints[this.handle].x / 100) * this.selectedItems.getIn([this.props.selectedItems.get(0), "width"]));
				this.prevY = ((this.pathData.controlPoints[this.handle].y / 100) * this.selectedItems.getIn([this.props.selectedItems.get(0), "height"]));
				var pathDetails = getPath(this.selectedItems.get(this.props.selectedItems.get(0)), this.props.zoomFactor, this.props.selectedObjects.get(this.props.selectedItems.get(0)));
				if (pathDetails.newControlPoints !== undefined && pathDetails.newControlPoints[this.handle] !== undefined) {
					this.prevX = ((pathDetails.newControlPoints[this.handle].x / 100) * this.selectedItems.getIn([this.props.selectedItems.get(0), "width"]));
					this.prevY = ((pathDetails.newControlPoints[this.handle].y / 100) * this.selectedItems.getIn([this.props.selectedItems.get(0), "height"]));
				}
			}
			window.addEventListener('mousemove', this.controlShape, false);
			window.addEventListener('mouseup', this.controlShape, false);
		}

		if (this.drag && (et === "mousemove" || et === "touchmove")) {

			let dx = (m.x - this.dPoint.x) / this.props.zoomFactor, dy = (m.y - this.dPoint.y) / this.props.zoomFactor;
			let adX = ((dx * Math.cos(this.angle * (Math.PI / 180))) + (dy * Math.sin(this.angle * (Math.PI / 180))));
			let adY = ((dy * Math.cos(this.angle * (Math.PI / 180))) - (dx * Math.sin(this.angle * (Math.PI / 180))));

			if (this.selectedItems.getIn([this.props.selectedItems.get(0), "flipPosition"]) === 1)
				adX *= -1;
			else if (this.selectedItems.getIn([this.props.selectedItems.get(0), "flipPosition"]) === 2)
				adY *= -1;
			else if (this.selectedItems.getIn([this.props.selectedItems.get(0), "flipPosition"]) === 3) {
				adX *= -1;
				adY *= -1;
			}

			let currentX = (this.moveType === "x" || this.moveType === "xy") ? this.prevX + adX : this.prevX;
			let currentY = (this.moveType === "y" || this.moveType === "xy") ? this.prevY + adY : this.prevY;

			let xPoint = (currentX / this.selectedItems.getIn([this.props.selectedItems.get(0), "width"])) * 100, yPoint = (currentY / this.selectedItems.getIn([this.props.selectedItems.get(0), "height"])) * 100;

			let currentPathData = fromJS(this.pathData).setIn(["controlPoints", this.handle, "x"], xPoint).setIn(["controlPoints", this.handle, "y"], yPoint);

			var pathDetails = getPath(this.selectedItems.setIn([this.props.selectedItems.get(0), "pathData"], fromJS(currentPathData)).get(this.props.selectedItems.get(0)), this.props.zoomFactor, this.props.selectedObjects.get(this.props.selectedItems.get(0)));
			let dataPath = pathDetails.pathDetails;
			if (Array.isArray(dataPath)) {
				for (let p = 0; p < dataPath.length; p++) {
					document.getElementById(this.props.selectedItems.get(0)).getElementsByTagName("svg")[0].getElementsByClassName("path" + p)[0].setAttribute("d", dataPath[p].data);

					if (dataPath[p].pathStyle !== undefined)
						document.getElementById(this.props.selectedItems.get(0)).getElementsByTagName("svg")[0].getElementsByTagName("g")[0].style.transform = "translate(" + dataPath[p].pathStyle.left + "px, " + dataPath[p].pathStyle.top + "px)";
				}
			}

			if (pathDetails.shapeStyle !== undefined) {
				document.getElementById(this.props.selectedItems.get(0)).getElementsByTagName("svg")[0].style.left = pathDetails.shapeStyle.left;
				document.getElementById(this.props.selectedItems.get(0)).getElementsByTagName("svg")[0].style.top = pathDetails.shapeStyle.top;
				document.getElementById(this.props.selectedItems.get(0)).getElementsByTagName("svg")[0].style.width = pathDetails.shapeStyle.width;
				document.getElementById(this.props.selectedItems.get(0)).getElementsByTagName("svg")[0].style.height = pathDetails.shapeStyle.height;
			}

			if (pathDetails.newControlPoints !== undefined) {
				let newControlPoints = this.getFlipPosition(pathDetails.newControlPoints, this.selectedItems.getIn([this.props.selectedItems.get(0), "flipPosition"]));
				for (let p in newControlPoints) {
					document.getElementsByClassName("control-point " + p)[0].style.left = "calc(" + newControlPoints[p].x + "% - 7.5px)";
					document.getElementsByClassName("control-point " + p)[0].style.top = "calc(" + newControlPoints[p].y + "% - 7.5px)";
				}
			}

		}

		if (this.drag && (et === "mouseup" || et === "touchend")) {

			let dx = (m.x - this.dPoint.x) / this.props.zoomFactor, dy = (m.y - this.dPoint.y) / this.props.zoomFactor;
			let adX = ((dx * Math.cos(this.angle * (Math.PI / 180))) + (dy * Math.sin(this.angle * (Math.PI / 180))));
			let adY = ((dy * Math.cos(this.angle * (Math.PI / 180))) - (dx * Math.sin(this.angle * (Math.PI / 180))));

			if (this.selectedItems.getIn([this.props.selectedItems.get(0), "flipPosition"]) === 1)
				adX *= -1;
			else if (this.selectedItems.getIn([this.props.selectedItems.get(0), "flipPosition"]) === 2)
				adY *= -1;
			else if (this.selectedItems.getIn([this.props.selectedItems.get(0), "flipPosition"]) === 3) {
				adX *= -1;
				adY *= -1;
			}

			let currentX = (this.moveType === "x" || this.moveType === "xy") ? this.prevX + adX : this.prevX;
			let currentY = (this.moveType === "y" || this.moveType === "xy") ? this.prevY + adY : this.prevY;

			let xPoint = (currentX / this.selectedItems.getIn([this.props.selectedItems.get(0), "width"])) * 100, yPoint = (currentY / this.selectedItems.getIn([this.props.selectedItems.get(0), "height"])) * 100;

			let currentPathData = fromJS(this.pathData).setIn(["controlPoints", this.handle, "x"], xPoint).setIn(["controlPoints", this.handle, "y"], yPoint);
			var pathDetails = getPath(this.selectedItems.setIn([this.props.selectedItems.get(0), "pathData"], fromJS(currentPathData)).get(this.props.selectedItems.get(0)), 1, this.props.selectedObjects.get(this.props.selectedItems.get(0)));

			let dataPath = pathDetails.pathDetails;

			this.props.updateItem({ selectedScene: this.props.selectedScene, container: "workspaceItems", selectedItem: this.props.selectedItems.get(0), toUpdate: { pathData: fromJS(pathDetails.pathData), path: dataPath } }, this.props.socket);


			this.drag = null, this.handle = null, this.pathData, this.prevX = null, this.prevY = null;
			window.removeEventListener('mousemove', this.controlShape, false);
			window.removeEventListener('mouseup', this.controlShape, false);
		}

	}

	moveControlPoint(e) {
		try {
		e.preventDefault();
		e.stopPropagation();

		var t = e.target, et = e.type, m = { x: e.pageX, y: e.pageY };
		var curWidth = this.selectedItems.getIn([this.props.selectedItems.get(0), "width"]);
		var curX = this.selectedItems.getIn([this.props.selectedItems.get(0), "x"]);
		var curY = this.selectedItems.getIn([this.props.selectedItems.get(0), "y"]);
		var curHeight = this.selectedItems.getIn([this.props.selectedItems.get(0), "height"]);


		if (et === "mousedown" || et === "touchstart") {
			if (!this.drag) {

				this.relativeXY = this.getXYRotation(curX + curWidth / 2, curY + curHeight / 2, curX, curY, this.selectedItems.getIn([this.props.selectedItems.get(0), "angle"]));
				this.drag = t;
				this.dPoint = m;

				this.handle = e.target.getAttribute("datahandle");
				this.pathData = this.selectedItems.getIn([this.props.selectedItems.get(0), "pathData"]).toJS();

				if (this.handle === "callout-tail") {

					this.calloutPath = document.getElementById(this.props.selectedItems.get(0)).getElementsByTagName("svg")[0].getElementsByClassName("center")[0].getElementsByClassName("calloutPath")[0];
					this.callout = document.getElementById(this.props.selectedItems.get(0)).getElementsByTagName("svg")[0].getElementsByClassName("center")[0].getElementsByClassName("callout")[0];
					this.tailElement = document.getElementById(this.props.selectedItems.get(0)).getElementsByTagName("svg")[0].getElementsByClassName("tail")[0];
					this.position = this.pathData.tail.position;

					var p = document.getElementById(this.props.selectedItems.get(0)).getElementsByTagName("svg")[0].createSVGPoint();
					p.x = e.clientX;
					p.y = e.clientY;
					m = this.tailElement.getScreenCTM();
					p = p.matrixTransform(m.inverse());

					this.nMouseOffsetX = p.x - parseInt(this.tailElement.getAttribute("cx"), 10);
					this.nMouseOffsetY = p.y - parseInt(this.tailElement.getAttribute("cy"), 10);

					var tmpPt = {
						x: p.x - this.nMouseOffsetX,
						y: p.y - this.nMouseOffsetY
					};

					this.actualLength = this.calloutPath.getTotalLength();

					var ptArray = [], segInc = 0, totLen = 0, individualPtArray = [];
					ptArray[segInc] = this.callout.getPointAtLength(0);
					ptArray[segInc].t = 0;
					var pathString = this.calloutPath.getAttributeNS(null, "d");
					this.pathArr = [];

					var _Data = pathString.slice(0, -1)
					var ptArrays = []
					ptArrays = _Data.split(" ");
					individualPtArray = _Data.split(" ");
					individualPtArray[0] = individualPtArray[0].substring(1)
					var tempArr = []
					var str = ptArrays[0]

					for (var i = 0; i < ptArrays.length - 1; i += 3) {
						if (i === 0) {
							tempArr.push(ptArrays[i] + " " + ptArrays[i + 1] + " " + ptArrays[i + 2] + " " + ptArrays[i + 3] + " ")
						} else {
							tempArr.push(ptArrays[i + 1] + " " + ptArrays[i + 2] + " " + ptArrays[i + 3] + " ")
						}
						str = str + " " + ptArrays[i + 1] + " " + ptArrays[i + 2] + " " + ptArrays[i + 3] + " "
						// updatePtArr(str)

						this.callout.setAttributeNS(null, 'd', str);
						totLen = this.callout.getTotalLength();
						ptArray[segInc] = this.callout.getPointAtLength(totLen);
						ptArray[segInc].t = totLen;
						segInc++;
					}


					this.cTail = this.pathData.tail.position;
					var callOffset = this.pathData.tail.offset;
					var endPt = this.cTail + callOffset;

					if (this.cTail < 0) {
						this.cTail = this.cTail + this.actualLength;
					}
					if (endPt > this.actualLength) {
						endPt = endPt - this.actualLength;
					}

					this.pt = this.calloutPath.getPointAtLength(this.cTail);

					this.pt2 = this.calloutPath.getPointAtLength(endPt);


					this.drawTail(this.pathData, this.calloutPath, this.callout, individualPtArray, ptArray, { x: tmpPt.x, y: tmpPt.y }, this.cTail, endPt);

					this.ptArray = ptArray;
					this.individualPtArray = individualPtArray;
				}

			}
			window.addEventListener('mousemove', this.moveControlPoint, false);
			window.addEventListener('mouseup', this.moveControlPoint, false);
		}

		if (this.drag && (et === "mousemove" || et === "touchmove")) {
			let actualWidth = this.pathData.bounds.width;
			let actualHeight = this.pathData.bounds.height;

			if (this.handle !== "callout-tail") {

				if (this.pathData.controlPoints.top) {
					var arr1, arr2;
					if (!this.pathData.isRectangle) {

						let dX = (m.x - this.dPoint.x) + ((this.pathData.controlPoints.top.x / 100) * curWidth);

						dX = (dX < 0) ? 0 : (dX > curWidth) ? curWidth : dX;
						let xPos = (dX / curWidth) * 100;

						let data = this.pathData.data;

						let pointArrays = data.split(" ");
						let ctrlPoint = actualWidth * (xPos / 100);
						var mY = (pointArrays[0].split(",")[1]);
						mY = Number(mY).toFixed(2);

						var newData = "";
						newData = "M" + ctrlPoint + "," + mY;

						for (i = 1; i < pointArrays.length; i += 3) {
							arr1 = pointArrays[i].substring(1).split(",");
							arr2 = pointArrays[i + 1].split(",");
							var arr3 = pointArrays[i + 2].split(",");
							var arrz = arr3[1].split("z")[0];

							var neutral1 = (i === 1) ? ctrlPoint : arr1[0];
							newData = newData + " C" + neutral1 + "," + arr1[1];

							var neutral2 = (i + 3 === pointArrays.length) ? ctrlPoint : arr2[0];
							newData = newData + " " + neutral2 + "," + arr2[1];

							var neutral3 = (i + 3 === pointArrays.length) ? ctrlPoint : arr3[0];
							newData = newData + " " + neutral3 + "," + arrz;
						}

						newData = newData + "z";

						this.drag.parentNode.style.left = "calc(" + xPos + "% - 9px)";
					} else {
						let dX = (((actualWidth * (this.pathData.controlPoints.top.x / 100)) + (m.x - this.dPoint.x)) / actualWidth) * 100;
						dX = (dX < 10) ? 10 : (dX > 45) ? 45 : dX;

						let data = this.pathData.data;
						let pointArrays = data.split(" ");
						pointArrays[pointArrays.length - 1] = pointArrays[pointArrays.length - 1].slice(0, -1);


						var cX = (pointArrays[1].split(",")[0]);
						cX = Number(cX.substring(1)).toFixed(2);
						var cY = (pointArrays[1].split(",")[1]);
						cY = Number(cY).toFixed(2);
						newData = ""
						newData = pointArrays[0];

						newData = newData + " C" + (Number(cX)) + "," + (Number(cY));
						let curviness = (dX / 100) * actualWidth;
						for (i = 2; i < pointArrays.length; i += 3) {
							var xadder = 0
							var yadder = 0
							arr1 = pointArrays[i].split(",");

							arr2 = pointArrays[i + 1].split(",");
							if (i !== pointArrays.length - 2)
								var arr3 = pointArrays[i + 2].substring(1).split(",");
							if (i === 5) {
								xadder = -curviness
							}
							if (i === 2) {
								yadder = -curviness
							}
							if (i === 8) {
								xadder = curviness
							}
							if (i === 11) {
								yadder = -curviness
							}
							if (i === 17) {
								xadder = curviness
							}
							if (i === 14) {
								yadder = curviness
							}
							if (i === 20) {
								xadder = -curviness
							}
							if (i === 23) {
								yadder = curviness
							}
							//newData=newData+" C"+arr1[0]+","+arr1[1];
							newData = newData + " " + (Number(arr1[0]) + xadder) + "," + (Number(arr1[1]) + yadder);
							newData = newData + " " + (Number(arr2[0]) + xadder) + "," + (Number(arr2[1]) + yadder);
							if (i !== pointArrays.length - 2)
								newData = newData + " C" + (Number(arr3[0])) + "," + (Number(arr3[1]));
						}
						newData = newData + "z";
						this.drag.parentNode.style.left = "calc(" + (dX) + "% - 6px)";
					}
					// this.drag.style.left = "calc("+ xPos +"% - 6px)";
					document.getElementById(this.props.selectedItems.get(0)).getElementsByTagName("svg")[0].getElementsByClassName("center")[0].getElementsByTagName("path")[0].setAttribute("d", newData);
				}
			} else {

				var cTail = this.cTail;
				var callOffset = this.pathData.tail.offset;
				var endPt = cTail + callOffset;
				// cTail = cTail + this.actualLength;

				let p = document.getElementById(this.props.selectedItems.get(0)).getElementsByTagName("svg")[0].createSVGPoint();
				p.x = e.clientX;
				p.y = e.clientY;
				var ctm = this.tailElement.getScreenCTM();
				p = p.matrixTransform(ctm.inverse());
				var tmpPt = {
					x: p.x - this.nMouseOffsetX,
					y: p.y - this.nMouseOffsetY
				};

				this.tailElement.setAttribute("cx", tmpPt.x);
				this.tailElement.setAttribute("cy", tmpPt.y);


				var midPoint = cTail + (callOffset / 2);
				midPoint = this.gradSearch(midPoint, tmpPt);
				cTail = midPoint - (callOffset / 2);
				endPt = cTail + callOffset;

				if (cTail < 0) {
					cTail = cTail + this.actualLength;
				}
				if (endPt > this.actualLength) {
					endPt = endPt - this.actualLength;
				}

				this.cTail = cTail;

				this.position = (this.cTail) / this.actualLength;

				let pt1 = this.calloutPath.getPointAtLength(this.cTail);

				let pt2 = this.calloutPath.getPointAtLength(endPt);

				var a_angle = (Math.atan2(pt1.y - pt2.y, pt1.x - pt2.x)) * (180 / Math.PI);
				a_angle = a_angle + 90
				a_angle = a_angle * (Math.PI / 180);

				var midPoint = this.cTail + (callOffset / 2);
				if (midPoint > this.actualLength)
					midPoint = midPoint - this.actualLength;


				let tailPoint = this.calloutPath.getPointAtLength(midPoint);

				let scaleX = this.selectedItems.getIn([this.props.selectedItems.get(0), "groupBounds", "center", "scaleX"]);
				let scaleY = this.selectedItems.getIn([this.props.selectedItems.get(0), "groupBounds", "center", "scaleY"]);
				let translateX = this.selectedItems.getIn([this.props.selectedItems.get(0), "groupBounds", "center", "x"]), translateY = this.selectedItems.getIn([this.props.selectedItems.get(0), "groupBounds", "center", "y"]);

				let dX = ((tailPoint.x + tmpPt.x) + (translateX - tailPoint.x));
				let dY = ((tailPoint.y + tmpPt.y) + (translateY - tailPoint.y));


				let svgX = 0, svgY = 0, distX = 0, distY = 0;
				if (dX < 0) {
					svgX = dX * scaleX;
					distX = this.pathData.bounds.width - dX;
				}

				if (dX > this.pathData.bounds.width) {
					distX = dX - this.pathData.bounds.width;
				}

				if (dY < 0) {
					svgY = dY * scaleY;
					distY = this.pathData.bounds.height - dY;
				}

				if (dY > this.pathData.bounds.height) {
					distY = dY - this.pathData.bounds.height;
				}

				let svgWidth = ((actualWidth + distX) * scaleX);
				let svgHeight = ((actualHeight + distY) * scaleY);


				document.getElementById(this.props.selectedItems.get(0)).getElementsByTagName("svg")[0].style.top = (svgY * this.props.zoomFactor) + "px";
				document.getElementById(this.props.selectedItems.get(0)).getElementsByTagName("svg")[0].style.left = (svgX * this.props.zoomFactor) + "px";

				document.getElementById(this.props.selectedItems.get(0)).getElementsByTagName("svg")[0].getElementsByClassName("center")[0].style.transform = "matrix(" + (scaleX * this.props.zoomFactor) + ", 0, 0, " + (scaleY * this.props.zoomFactor) + ", " + ((translateX - svgX) * this.props.zoomFactor) + ", " + ((translateY - svgY) * this.props.zoomFactor) + ")";


				// if(actualWidth < svgWidth){
				document.getElementById(this.props.selectedItems.get(0)).getElementsByTagName("svg")[0].style.width = (svgWidth) + "px";
				// }
				// if(actualHeight < svgHeight){
				document.getElementById(this.props.selectedItems.get(0)).getElementsByTagName("svg")[0].style.height = (svgHeight - svgY) + "px";
				// }

				this.drawTail(this.pathData, this.calloutPath, this.callout, this.individualPtArray, this.ptArray, { x: tmpPt.x, y: tmpPt.y }, this.cTail, endPt);
				this.drag.parentNode.style.left = ((tmpPt.x * scaleX * this.props.zoomFactor) - 10) + "px";
				this.drag.parentNode.style.top = ((tmpPt.y * scaleY * this.props.zoomFactor) - 10) + "px";

			}
		}

		if (this.drag && (et === "mouseup" || et === "touchend")) {
			let actualWidth = this.pathData.bounds.width;
			let actualHeight = this.pathData.bounds.height;
			if (this.handle !== "callout-tail") {
				if (this.pathData.controlPoints.top) {
					if (!this.pathData.isRectangle) {
						let dX = (m.x - this.dPoint.x) + ((this.pathData.controlPoints.top.x / 100) * curWidth);

						dX = (dX < 0) ? 0 : (dX > curWidth) ? curWidth : dX;
						let xPos = (dX / curWidth) * 100;
						this.pathData.controlPoints.top.x = xPos;
					} else {
						let dX = (((actualWidth * (this.pathData.controlPoints.top.x / 100)) + (m.x - this.dPoint.x)) / actualWidth) * 100;
						dX = (dX < 10) ? 10 : (dX > 45) ? 45 : dX;

						this.pathData.controlPoints.top.x = dX;
					}
					let svgPath = document.getElementById(this.props.selectedItems.get(0)).getElementsByTagName("svg")[0].getElementsByClassName("center")[0].getElementsByTagName("path")[0].getAttribute("d");

					this.props.updateObjectById({ selectedScene: this.props.selectedScene, container: "workspaceItems", id: this.props.selectedItems.get(0), toUpdate: { pathData: this.pathData, path: [svgPath] } }, this.props.socket);
				}
			} else {

				let p = document.getElementById(this.props.selectedItems.get(0)).getElementsByTagName("svg")[0].createSVGPoint();
				p.x = e.clientX;
				p.y = e.clientY;
				var ctm = this.tailElement.getScreenCTM();
				p = p.matrixTransform(ctm.inverse());
				var tmpPt = {
					x: p.x - this.nMouseOffsetX,
					y: p.y - this.nMouseOffsetY
				};

				var endPt = this.cTail + this.pathData.tail.offset;

				if (this.cTail < 0) {
					this.cTail = this.cTail + this.actualLength;
				}
				if (endPt > this.actualLength) {
					endPt = endPt - this.actualLength;
				}


				this.drawTail(this.pathData, this.calloutPath, this.callout, this.individualPtArray, this.ptArray, { x: tmpPt.x, y: tmpPt.y }, this.cTail, endPt, true);

				this.pathData.tail.position = this.cTail;
				this.pathData.tail.point = tmpPt;

				var midPoint = this.cTail + (this.pathData.tail.offset / 2);
				if (midPoint > this.actualLength)
					midPoint = midPoint - this.actualLength;

				this.pathData.tail.distance = -this.dist(this.calloutPath.getPointAtLength(midPoint), tmpPt);
				this.props.updateObjectById({ selectedScene: this.props.selectedScene, container: "workspaceItems", id: this.props.selectedItems.get(0), toUpdate: { pathData: this.pathData } }, this.props.socket);

				this.pathArr = null;
				this.callout = null;
				this.calloutPath = null;
				this.actualLength = null;
				this.ptArray = null;
				this.individualPtArray = null;
				this.pt = null;
				this.pt3 = null;
				this.tailElement = null;
				this.nMouseOffsetX = null;
				this.nMouseOffsetY = null;


			}
			this.drag = null, this.handle = null, this.relativeXY = null;
			window.removeEventListener('mousemove', this.moveControlPoint, false);
			window.removeEventListener('mouseup', this.moveControlPoint, false);
		}
	} catch (error) {
		//Error Severity: LOW
		errorlog(error, error.message, "TransformManagerComponent-moveControlPoint")
	}
	}

	getFlipPosition(controlPoints, flipPosition) {
		if (flipPosition === 1) {
			for (let key in controlPoints) {
				controlPoints[key].x = 100 - controlPoints[key].x;
			}
		} else if (flipPosition === 2) {
			for (let key in controlPoints) {
				controlPoints[key].y = 100 - controlPoints[key].y;
			}
		}
		else if (flipPosition === 3) {
			for (let key in controlPoints) {
				controlPoints[key].x = 100 - controlPoints[key].x;
				controlPoints[key].y = 100 - controlPoints[key].y;
			}
		}
		return controlPoints;
	}


	render() {

		var selectionBounds = {};
		if (!this.transformingByKey)
			selectionBounds = this.getSelectionBox();
		else
			selectionBounds = this.selectionBox;

		var selection_styles = { 
			transform: "translate(" + parseFloat(selectionBounds.x * this.props.zoomFactor).toFixed(2) + "px, " + parseFloat(selectionBounds.y * this.props.zoomFactor).toFixed(2) + "px) rotateZ(" + selectionBounds.angle + "deg)", 
			width: selectionBounds.width * this.props.zoomFactor, 
			height: selectionBounds.height * this.props.zoomFactor,
			userSelect: 'none',
			pointerEvents: (this.isShapeOnly()&&!this.props.textStatus.get("isFocused"))?undefined:'none'

			};


		var id = null;
		// selection_styles.display = "none";
		var selectionBoxClass = "selectionBox";
		var innerBoxClass = "inner-box";
		var handlesClass = "handles";

		if (this.isTextOnly()) {
			selectionBoxClass += " text-only";
		}

		if (this.isPermenantGroup() || this.isTextOnly() || this.isCalloutOnly()) {
			selectionBoxClass += " text-content";
		}

		if (this.props.lockTransform) {
			innerBoxClass += " hide pointer-events-none";
			handlesClass += " hide pointer-events-none";
		}

		if (this.props.textStatus.get("isFocused")) {
			selectionBoxClass += " pointer-events-none";
			handlesClass += " pointer-events-auto";
		}

		if (this.selectionBox.angle >= 337.5 || this.selectionBox.angle <= 22.5)
			selectionBoxClass += " e"
		else if (this.selectionBox.angle >= 22.5 && this.selectionBox.angle <= 67.5)
			selectionBoxClass += " se"
		else if (this.selectionBox.angle >= 67.5 && this.selectionBox.angle <= 112.5)
			selectionBoxClass += " s"
		else if (this.selectionBox.angle >= 112.5 && this.selectionBox.angle <= 157.5)
			selectionBoxClass += " sw"
		else if (this.selectionBox.angle >= 157.5 && this.selectionBox.angle <= 202.5)
			selectionBoxClass += " w"
		else if (this.selectionBox.angle >= 202.5 && this.selectionBox.angle <= 247.5)
			selectionBoxClass += " nw"
		else if (this.selectionBox.angle >= 247.5 && this.selectionBox.angle <= 292.5)
			selectionBoxClass += " n"
		else if (this.selectionBox.angle >= 292.5 && this.selectionBox.angle <= 337.5)
			selectionBoxClass += " ne"

		if (this.props.transformStatus.get("transforming") && (this.props.selectedCamera === "" || this.props.selectedCamera === undefined))
			selectionBoxClass += " invisible";

		if (this.props.isToolCropping)
			selectionBoxClass += " tool-crop";

		var controlPoints = [];

		if (this.isShapeOnly() ) {

			if (this.selectedItems.getIn([this.props.selectedItems.get(0), "subType"]) === "CSTMPTH") {


				let pathDetails = getPath(this.selectedItems.get(this.props.selectedItems.get(0)), this.props.zoomFactor, this.props.selectedObjects.get(this.props.selectedItems.get(0)));
				let pathData = fromJS(pathDetails.pathData);

				if (pathDetails.newControlPoints !== undefined) {
					let flilpPostion = this.selectedItems.getIn([this.props.selectedItems.get(0), "flipPosition"]);
					let newControlPoints = this.getFlipPosition(pathDetails.newControlPoints, flilpPostion);
					for (let p in newControlPoints) {
						controlPoints.push(
							<span key={p} className={"control-point " + p} style={{ left: "calc(" + newControlPoints[p].x + "% - 7.5px)", top: "calc(" + newControlPoints[p].y + "% - 7.5px)", display: "block" }} datahandle={p} onMouseDown={this.controlShape}><img datahandle={p} src={this.appUrl + "/images/property-icons/control-point.svg"} /></span>
						);
					}
				}

				else if (pathData) {
					pathData.get("controlPoints").entrySeq().forEach(([key, pos]) => {

						controlPoints.push(
							<span key={key} className={"control-point " + key} style={{ left: "calc(" + pos.get("x") + "% - 7.5px)", top: "calc(" + pos.get("y") + "% - 7.5px)", display: "block" }} datahandle={key} onMouseDown={this.controlShape}><img datahandle={key} src={this.appUrl + "/images/property-icons/control-point.svg"} /></span>
						);
					});

				}
			}
			else if (this.selectedItems.getIn([this.props.selectedItems.get(0), "pathData", "controlPoints"])) {
				let pathData = this.selectedItems.getIn([this.props.selectedItems.get(0), "pathData"]);
				if (pathData) {
					pathData.get("controlPoints").entrySeq().forEach(([key, pos]) => {
						if (key === "top" || key === "right" || key === "bottom" || key === "left") {
							let left = this.selectedItems.getIn([this.props.selectedItems.get(0), "width"]) * (pos.get("x") / 100), top = this.selectedItems.getIn([this.props.selectedItems.get(0), "height"]) * (pos.get("y") / 100);

							controlPoints.push(
								<span key={key} className={"control-point " + key} style={{ left: "calc(" + pos.get("x") + "% - 9px)", top: (top - 9) + "px", display: "block" }} datahandle={key} onMouseDown={this.moveControlPoint}><img datahandle={key} src={this.appUrl + "/images/property-icons/control-point.svg"} /></span>
							);
						} else {
							let left = pos, top = pos;

							let style = {};
							if (key === "topLeft")
								style = { left: (left - 9) + "px", top: (top - 9) + "px" };
							else if (key === "topRight")
								style = { right: (left - 9) + "px", top: (top - 9) + "px" };
							else if (key === "bottomRight")
								style = { right: (left - 9) + "px", bottom: (top - 9) + "px" };
							else if (key === "bottomLeft")
								style = { left: (left - 9) + "px", bottom: (top - 9) + "px" };

							controlPoints.push(
								<span key={key} className={"control-point " + key} style={style} datahandle={key} onMouseDown={this.moveControlPoint}><img datahandle={key} src={this.appUrl + "/images/property-icons/control-point.svg"} /></span>
							);
						}
					});
				}
			} else if (this.selectedItems.getIn([this.props.selectedItems.get(0), "subType"]) === "CALLOUT") {

				let calloutTail = this.selectedItems.getIn([this.props.selectedItems.get(0), "pathData", "tail"]).toJS();
				var callout = document.getElementById(this.props.selectedItems.get(0)).getElementsByClassName("center")[0].getElementsByClassName("callout")[0];
				var calloutPath = document.getElementById(this.props.selectedItems.get(0)).getElementsByClassName("center")[0].getElementsByClassName("calloutPath")[0];
				var actualLength = calloutPath.getTotalLength();

				var cTail = calloutTail.position;
				var callOffset = calloutTail.offset;
				var endPt = cTail + callOffset;

				var pt = calloutPath.getPointAtLength(cTail);
				var pt2 = calloutPath.getPointAtLength(endPt);

				var a_angle = (Math.atan2(pt.y - pt2.y, pt.x - pt2.x)) * (180 / Math.PI);
				a_angle = a_angle + 90;
				a_angle = a_angle * (Math.PI / 180);

				var midPoint = cTail + (callOffset / 2);
				if (midPoint > actualLength)
					midPoint = midPoint - actualLength;
				var pt3 = calloutPath.getPointAtLength(midPoint);
				let scaleX = this.selectedItems.getIn([this.props.selectedItems.get(0), "groupBounds", "center", "scaleX"]);
				let scaleY = this.selectedItems.getIn([this.props.selectedItems.get(0), "groupBounds", "center", "scaleY"]);
				var dx2 = calloutTail.point.x;
				var dy2 = calloutTail.point.y;

				let style = { top: ((dy2 * scaleY * this.props.zoomFactor) - 10) + "px", left: ((dx2 * scaleX * this.props.zoomFactor) - (10)) + "px" };
				controlPoints.push(
					<span key="clt" className={"control-point callout-tail"} style={style} datahandle="callout-tail" onMouseDown={this.moveControlPoint}><img datahandle="callout-tail" src={this.appUrl + "/images/property-icons/control-point.svg"} /></span>
				);
			}
		}


		let transformManager;
		transformManager = <div data-html2canvas-ignore="true" key={this.props.keyframe} className={selectionBoxClass} ref={(instance) => this.selectionBoxElement = instance} data-id={id} style={selection_styles} >
			<div className={innerBoxClass} data-id={id} onMouseDown={this.initiateMove} onMouseEnter={(e) => this.setCursor(e, "move")} onMouseLeave={(e) => this.resetCursor(e)} >
			</div>
			<div className={handlesClass} style={{pointerEvents: 'auto'}}>
				{controlPoints}
				{(this.isTextOnly() && this.props.textStatus.get("isFocused")) ? <span className="text-inner-box" data-id={id} onMouseDown={this.initiateMove} onMouseEnter={(e) => this.setCursor(e, "move")} onMouseLeave={(e) => this.resetCursor(e)} style={{ top: "-15px", left: "-15px", right: "-15px", height: "15px", position: "absolute" }}></span> : null}
				{(this.isTextOnly() && this.props.textStatus.get("isFocused")) ? <span className="text-inner-box" data-id={id} onMouseDown={this.initiateMove} onMouseEnter={(e) => this.setCursor(e, "move")} onMouseLeave={(e) => this.resetCursor(e)} style={{ top: "-15px", right: "-15px", bottom: "-15px", width: "15px", position: "absolute" }}></span> : null}
				{(this.isTextOnly() && this.props.textStatus.get("isFocused")) ? <span className="text-inner-box" data-id={id} onMouseDown={this.initiateMove} onMouseEnter={(e) => this.setCursor(e, "move")} onMouseLeave={(e) => this.resetCursor(e)} style={{ left: "-15px", right: "-15px", bottom: "-15px", height: "15px", position: "absolute" }}></span> : null}
				{(this.isTextOnly() && this.props.textStatus.get("isFocused")) ? <span className="text-inner-box" data-id={id} onMouseDown={this.initiateMove} onMouseEnter={(e) => this.setCursor(e, "move")} onMouseLeave={(e) => this.resetCursor(e)} style={{ left: "-15px", top: "-15px", bottom: "-15px", width: "15px", position: "absolute" }}></span> : null}

				<span className={"resize-handle top-left" + (((this.props.transformStatus.get("resizing") || this.props.transformStatus.get("rotating")) && this.selectionBox.handle === "top-left") || this.props.isToolCropping ? " active" : "")} data-handle="top-left" onMouseDown={this.initiateResize} onMouseEnter={(e) => this.setCursor(e, "resize")} onMouseLeave={(e) => this.resetCursor(e)}></span>
				<span className={"rotate-handle top-left" + (this.props.selectedItems.size === 0 ? " disabled" : "")} data-handle="top-left" onMouseDown={this.initiateRotate} onMouseEnter={(e) => this.setCursor(e, "rotate")} onMouseLeave={(e) => this.resetCursor(e)}></span>

				<span className={"resize-handle top" + (this.isVerticalScale() ? "" : " disabled") + ((this.props.transformStatus.get("resizing") || this.props.transformStatus.get("rotating")) && this.selectionBox.handle === "top" ? " active" : "") + ((selectionBounds.width * this.props.zoomFactor) > 60 ? "" : " hide-handle")} data-handle="top" onMouseDown={this.initiateResize} onMouseEnter={(e) => this.setCursor(e, "resize")} onMouseLeave={(e) => this.resetCursor(e)}></span>

				<span className={"resize-handle top-right" + (((this.props.transformStatus.get("resizing") || this.props.transformStatus.get("rotating")) && this.selectionBox.handle === "top-right") || this.props.isToolCropping ? " active" : "")} data-handle="top-right" onMouseDown={this.initiateResize} onMouseEnter={(e) => this.setCursor(e, "resize")} onMouseLeave={(e) => this.resetCursor(e)}></span>
				<span className={"rotate-handle top-right" + (this.props.selectedItems.size === 0 ? " disabled" : "")} data-handle="top-right" onMouseDown={this.initiateRotate} onMouseEnter={(e) => this.setCursor(e, "rotate")} onMouseLeave={(e) => this.resetCursor(e)}></span>

				<span className={"resize-handle right" + (this.isHorizontalScale() ? "" : " disabled") + (((this.props.transformStatus.get("resizing") || this.props.transformStatus.get("rotating")) && this.selectionBox.handle === "right") || this.props.isToolCropping ? " active" : "") + ((selectionBounds.height * this.props.zoomFactor) > 60 ? "" : " hide-handle")} data-handle="right" onMouseDown={this.initiateResize} onMouseEnter={(e) => this.setCursor(e, "resize")} onMouseLeave={(e) => this.resetCursor(e)}></span>

				<span className={"resize-handle bottom-left" + (((this.props.transformStatus.get("resizing") || this.props.transformStatus.get("rotating")) && this.selectionBox.handle === "bottom-left") || this.props.isToolCropping ? " active" : "")} data-handle="bottom-left" onMouseDown={this.initiateResize} onMouseEnter={(e) => this.setCursor(e, "resize")} onMouseLeave={(e) => this.resetCursor(e)}></span>
				<span className={"rotate-handle bottom-left" + (this.props.selectedItems.size === 0 ? " disabled" : "")} data-handle="bottom-left" onMouseDown={this.initiateRotate} onMouseEnter={(e) => this.setCursor(e, "rotate")} onMouseLeave={(e) => this.resetCursor(e)}></span>

				<span className={"resize-handle bottom" + (this.isVerticalScale() ? "" : " disabled") + ((this.props.transformStatus.get("resizing")) && this.selectionBox.handle === "bottom" ? " active" : "") + ((selectionBounds.width * this.props.zoomFactor) > 60 ? "" : " hide-handle")} data-handle="bottom" onMouseDown={this.initiateResize} onMouseEnter={(e) => this.setCursor(e, "resize")} onMouseLeave={(e) => this.resetCursor(e)}></span>

				<span className={"resize-handle bottom-right" + (((this.props.transformStatus.get("resizing") || this.props.transformStatus.get("rotating")) && this.selectionBox.handle === "bottom-right") || this.props.isToolCropping ? " active" : "")} data-handle="bottom-right" onMouseDown={this.initiateResize} onMouseEnter={(e) => this.setCursor(e, "resize")} onMouseLeave={(e) => this.resetCursor(e)}></span>
				<span className={"rotate-handle bottom-right" + (this.props.selectedItems.size === 0 ? " disabled" : "")} data-handle="bottom-right" onMouseDown={this.initiateRotate} onMouseEnter={(e) => this.setCursor(e, "rotate")} onMouseLeave={(e) => this.resetCursor(e)}></span>
				{(this.props.selectedItems.size > 0) ? <span className={"rotate-handle bottom" + ((this.props.transformStatus.get("resizing") || this.props.transformStatus.get("rotating")) && this.selectionBox.handle === "bottom" ? " active" : "")} data-handle="bottom" onMouseDown={this.initiateRotate} onMouseEnter={(e) => this.setCursor(e, "rotate")} onMouseLeave={(e) => this.resetCursor(e)}></span> : null}

				<span className={"resize-handle left" + (this.isHorizontalScale() ? "" : " disabled") + ((this.props.transformStatus.get("resizing") || this.props.transformStatus.get("rotating")) && this.selectionBox.handle === "left" ? " active" : "") + ((selectionBounds.height * this.props.zoomFactor) > 60 ? "" : " hide-handle")} data-handle="left" onMouseDown={this.initiateResize} onMouseEnter={(e) => this.setCursor(e, "resize")} onMouseLeave={(e) => this.resetCursor(e)}></span>
			</div>
		</div>
		// if (this.props.animakerType === 'lite') {
		//   selectionBoxClass = selectionBoxClass + " lite-selection"
		//   transformManager = <div key={this.props.keyframe} className={selectionBoxClass} ref={(instance) => this.selectionBoxElement = instance} data-id={id} style={selection_styles} >
		//     <div className={innerBoxClass} data-id={id} onMouseEnter={(e) => this.setCursor(e, "move")} onMouseLeave={(e) => this.resetCursor(e)} >
		//     </div>
		//   </div>

		// }


		return (
			<React.Fragment>
				{transformManager}
			</React.Fragment>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/TransformManagerComponent.js